export const PAGE_1 = {
    property: {
        detectedLanguages: [
            {
                languageCode: 'en',
                confidence: 0.99,
            },
            {
                languageCode: 'it',
                confidence: 0.01,
            },
        ],
    },
    width: 595,
    height: 841,
    blocks: [
        {
            property: {
                detectedLanguages: [
                    {
                        languageCode: 'it',
                        confidence: 1,
                    },
                ],
            },
            boundingBox: {
                normalizedVertices: [
                    {
                        x: 0.8302521,
                        y: 0.07609988,
                    },
                    {
                        x: 0.9327731,
                        y: 0.07609988,
                    },
                    {
                        x: 0.9327731,
                        y: 0.09155767,
                    },
                    {
                        x: 0.8302521,
                        y: 0.09155767,
                    },
                ],
            },
            paragraphs: [
                {
                    property: {
                        detectedLanguages: [
                            {
                                languageCode: 'it',
                                confidence: 1,
                            },
                        ],
                    },
                    boundingBox: {
                        normalizedVertices: [
                            {
                                x: 0.8302521,
                                y: 0.07609988,
                            },
                            {
                                x: 0.9327731,
                                y: 0.07609988,
                            },
                            {
                                x: 0.9327731,
                                y: 0.09155767,
                            },
                            {
                                x: 0.8302521,
                                y: 0.09155767,
                            },
                        ],
                    },
                    words: [
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'it',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.8302521,
                                        y: 0.07609988,
                                    },
                                    {
                                        x: 0.9327731,
                                        y: 0.07609988,
                                    },
                                    {
                                        x: 0.9327731,
                                        y: 0.09155767,
                                    },
                                    {
                                        x: 0.8302521,
                                        y: 0.09155767,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'it',
                                            },
                                        ],
                                    },
                                    text: 'G',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'it',
                                            },
                                        ],
                                    },
                                    text: 'E',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'it',
                                            },
                                        ],
                                    },
                                    text: 'N',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'it',
                                            },
                                        ],
                                    },
                                    text: 'E',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'it',
                                            },
                                        ],
                                    },
                                    text: 'R',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'it',
                                            },
                                        ],
                                    },
                                    text: 'A',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'it',
                                            },
                                        ],
                                    },
                                    text: 'L',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'it',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'LINE_BREAK',
                                        },
                                    },
                                    text: 'I',
                                    confidence: 0.99,
                                },
                            ],
                            confidence: 0.99,
                        },
                    ],
                    confidence: 0.99,
                },
            ],
            blockType: 'TEXT',
            confidence: 0.99,
        },
        {
            property: {
                detectedLanguages: [
                    {
                        languageCode: 'en',
                        confidence: 1,
                    },
                ],
            },
            boundingBox: {
                normalizedVertices: [
                    {
                        x: 0.1764706,
                        y: 0.16052319,
                    },
                    {
                        x: 0.48739496,
                        y: 0.16052319,
                    },
                    {
                        x: 0.48739496,
                        y: 0.17598097,
                    },
                    {
                        x: 0.1764706,
                        y: 0.17598097,
                    },
                ],
            },
            paragraphs: [
                {
                    property: {
                        detectedLanguages: [
                            {
                                languageCode: 'en',
                                confidence: 1,
                            },
                        ],
                    },
                    boundingBox: {
                        normalizedVertices: [
                            {
                                x: 0.1764706,
                                y: 0.16052319,
                            },
                            {
                                x: 0.48739496,
                                y: 0.16052319,
                            },
                            {
                                x: 0.48739496,
                                y: 0.17598097,
                            },
                            {
                                x: 0.1764706,
                                y: 0.17598097,
                            },
                        ],
                    },
                    words: [
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.1764706,
                                        y: 0.16052319,
                                    },
                                    {
                                        x: 0.25042018,
                                        y: 0.16052319,
                                    },
                                    {
                                        x: 0.25042018,
                                        y: 0.17598097,
                                    },
                                    {
                                        x: 0.1764706,
                                        y: 0.17598097,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'G',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'n',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'r',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'a',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'l',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.26050422,
                                        y: 0.16052319,
                                    },
                                    {
                                        x: 0.3159664,
                                        y: 0.16052319,
                                    },
                                    {
                                        x: 0.3159664,
                                        y: 0.17598097,
                                    },
                                    {
                                        x: 0.26050422,
                                        y: 0.17598097,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'P',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'o',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'l',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'i',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'c',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'y',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.3226891,
                                        y: 0.16052319,
                                    },
                                    {
                                        x: 0.42689076,
                                        y: 0.16052319,
                                    },
                                    {
                                        x: 0.42689076,
                                        y: 0.17598097,
                                    },
                                    {
                                        x: 0.3226891,
                                        y: 0.17598097,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'C',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'o',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'n',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'd',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'i',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 't',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'i',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'o',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'n',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 's',
                                    confidence: 0.97,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.43361345,
                                        y: 0.16052319,
                                    },
                                    {
                                        x: 0.43865547,
                                        y: 0.16052319,
                                    },
                                    {
                                        x: 0.43865547,
                                        y: 0.17598097,
                                    },
                                    {
                                        x: 0.43361345,
                                        y: 0.17598097,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: '(',
                                    confidence: 0.99,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.43865547,
                                        y: 0.16052319,
                                    },
                                    {
                                        x: 0.48067227,
                                        y: 0.16052319,
                                    },
                                    {
                                        x: 0.48067227,
                                        y: 0.17598097,
                                    },
                                    {
                                        x: 0.43865547,
                                        y: 0.17598097,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'G',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'P',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'C',
                                    confidence: 0.99,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.48235294,
                                        y: 0.16052319,
                                    },
                                    {
                                        x: 0.48739496,
                                        y: 0.16052319,
                                    },
                                    {
                                        x: 0.48739496,
                                        y: 0.17598097,
                                    },
                                    {
                                        x: 0.48235294,
                                        y: 0.17598097,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'LINE_BREAK',
                                        },
                                    },
                                    text: ')',
                                    confidence: 0.99,
                                },
                            ],
                            confidence: 0.99,
                        },
                    ],
                    confidence: 0.99,
                },
            ],
            blockType: 'TEXT',
            confidence: 0.99,
        },
        {
            property: {
                detectedLanguages: [
                    {
                        languageCode: 'en',
                        confidence: 1,
                    },
                ],
            },
            boundingBox: {
                normalizedVertices: [
                    {
                        x: 0.17815126,
                        y: 0.17954816,
                    },
                    {
                        x: 0.5159664,
                        y: 0.17954816,
                    },
                    {
                        x: 0.5159664,
                        y: 0.21046373,
                    },
                    {
                        x: 0.17815126,
                        y: 0.21046373,
                    },
                ],
            },
            paragraphs: [
                {
                    property: {
                        detectedLanguages: [
                            {
                                languageCode: 'en',
                                confidence: 1,
                            },
                        ],
                    },
                    boundingBox: {
                        normalizedVertices: [
                            {
                                x: 0.17815126,
                                y: 0.17954816,
                            },
                            {
                                x: 0.5159664,
                                y: 0.17954816,
                            },
                            {
                                x: 0.5159664,
                                y: 0.21046373,
                            },
                            {
                                x: 0.17815126,
                                y: 0.21046373,
                            },
                        ],
                    },
                    words: [
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.17815126,
                                        y: 0.17954816,
                                    },
                                    {
                                        x: 0.297479,
                                        y: 0.17954816,
                                    },
                                    {
                                        x: 0.297479,
                                        y: 0.21046373,
                                    },
                                    {
                                        x: 0.17815126,
                                        y: 0.21046373,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'T',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'r',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'a',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'v',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'l',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.31428573,
                                        y: 0.17954816,
                                    },
                                    {
                                        x: 0.5159664,
                                        y: 0.17954816,
                                    },
                                    {
                                        x: 0.5159664,
                                        y: 0.21046373,
                                    },
                                    {
                                        x: 0.31428573,
                                        y: 0.21046373,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'i',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'n',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 's',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'u',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'r',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'a',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'n',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'c',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'LINE_BREAK',
                                        },
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                    ],
                    confidence: 0.99,
                },
            ],
            blockType: 'TEXT',
            confidence: 0.99,
        },
        {
            property: {
                detectedLanguages: [
                    {
                        languageCode: 'en',
                        confidence: 1,
                    },
                ],
            },
            boundingBox: {
                normalizedVertices: [
                    {
                        x: 0.17815126,
                        y: 0.23067777,
                    },
                    {
                        x: 0.39159665,
                        y: 0.23067777,
                    },
                    {
                        x: 0.39159665,
                        y: 0.2449465,
                    },
                    {
                        x: 0.17815126,
                        y: 0.2449465,
                    },
                ],
            },
            paragraphs: [
                {
                    property: {
                        detectedLanguages: [
                            {
                                languageCode: 'en',
                                confidence: 1,
                            },
                        ],
                    },
                    boundingBox: {
                        normalizedVertices: [
                            {
                                x: 0.17815126,
                                y: 0.23067777,
                            },
                            {
                                x: 0.39159665,
                                y: 0.23067777,
                            },
                            {
                                x: 0.39159665,
                                y: 0.2449465,
                            },
                            {
                                x: 0.17815126,
                                y: 0.2449465,
                            },
                        ],
                    },
                    words: [
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.17815126,
                                        y: 0.23067777,
                                    },
                                    {
                                        x: 0.2420168,
                                        y: 0.23067777,
                                    },
                                    {
                                        x: 0.2420168,
                                        y: 0.2449465,
                                    },
                                    {
                                        x: 0.17815126,
                                        y: 0.2449465,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'E',
                                    confidence: 0.91,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'd',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'i',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 't',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'i',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'o',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'n',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.98,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.25042018,
                                        y: 0.23067777,
                                    },
                                    {
                                        x: 0.29075631,
                                        y: 0.23067777,
                                    },
                                    {
                                        x: 0.29075631,
                                        y: 0.2449465,
                                    },
                                    {
                                        x: 0.25042018,
                                        y: 0.2449465,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: '2',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: '0',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: '2',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: '1',
                                    confidence: 0.99,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.29579833,
                                        y: 0.23067777,
                                    },
                                    {
                                        x: 0.29915968,
                                        y: 0.23067777,
                                    },
                                    {
                                        x: 0.29915968,
                                        y: 0.2449465,
                                    },
                                    {
                                        x: 0.29579833,
                                        y: 0.2449465,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: ',',
                                    confidence: 1,
                                },
                            ],
                            confidence: 1,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.30588236,
                                        y: 0.23067777,
                                    },
                                    {
                                        x: 0.37478992,
                                        y: 0.23067777,
                                    },
                                    {
                                        x: 0.37478992,
                                        y: 0.2449465,
                                    },
                                    {
                                        x: 0.30588236,
                                        y: 0.2449465,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'v',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'r',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 's',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'i',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'o',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'n',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.3815126,
                                        y: 0.23067777,
                                    },
                                    {
                                        x: 0.39159665,
                                        y: 0.23067777,
                                    },
                                    {
                                        x: 0.39159665,
                                        y: 0.2449465,
                                    },
                                    {
                                        x: 0.3815126,
                                        y: 0.2449465,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'LINE_BREAK',
                                        },
                                    },
                                    text: '2',
                                    confidence: 0.99,
                                },
                            ],
                            confidence: 0.99,
                        },
                    ],
                    confidence: 0.99,
                },
            ],
            blockType: 'TEXT',
            confidence: 0.99,
        },
        {
            property: {
                detectedLanguages: [
                    {
                        languageCode: 'en',
                        confidence: 1,
                    },
                ],
            },
            boundingBox: {
                normalizedVertices: [
                    {
                        x: 0.1764706,
                        y: 0.30558857,
                    },
                    {
                        x: 0.5126051,
                        y: 0.30439952,
                    },
                    {
                        x: 0.5126051,
                        y: 0.32104638,
                    },
                    {
                        x: 0.1764706,
                        y: 0.32223544,
                    },
                ],
            },
            paragraphs: [
                {
                    property: {
                        detectedLanguages: [
                            {
                                languageCode: 'en',
                                confidence: 1,
                            },
                        ],
                    },
                    boundingBox: {
                        normalizedVertices: [
                            {
                                x: 0.1764706,
                                y: 0.30558857,
                            },
                            {
                                x: 0.5126051,
                                y: 0.30439952,
                            },
                            {
                                x: 0.5126051,
                                y: 0.32104638,
                            },
                            {
                                x: 0.1764706,
                                y: 0.32223544,
                            },
                        ],
                    },
                    words: [
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.1764706,
                                        y: 0.30558857,
                                    },
                                    {
                                        x: 0.27058825,
                                        y: 0.30558857,
                                    },
                                    {
                                        x: 0.27058825,
                                        y: 0.32223544,
                                    },
                                    {
                                        x: 0.1764706,
                                        y: 0.32223544,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'I',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'm',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'p',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'o',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'r',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 't',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'a',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'n',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 't',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.2789916,
                                        y: 0.30558857,
                                    },
                                    {
                                        x: 0.39663866,
                                        y: 0.30439952,
                                    },
                                    {
                                        x: 0.39663866,
                                        y: 0.32223544,
                                    },
                                    {
                                        x: 0.2789916,
                                        y: 0.32223544,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'i',
                                    confidence: 0.98,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'n',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 't',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'r',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'o',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'd',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'u',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'c',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 't',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'o',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'r',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'y',
                                    confidence: 0.99,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.40504202,
                                        y: 0.30439952,
                                    },
                                    {
                                        x: 0.5126051,
                                        y: 0.30439952,
                                    },
                                    {
                                        x: 0.5126051,
                                        y: 0.32104638,
                                    },
                                    {
                                        x: 0.40504202,
                                        y: 0.32104638,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'i',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'n',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'f',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'o',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'r',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'm',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'a',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 't',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'i',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'o',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'LINE_BREAK',
                                        },
                                    },
                                    text: 'n',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                    ],
                    confidence: 0.99,
                },
            ],
            blockType: 'TEXT',
            confidence: 0.99,
        },
        {
            property: {
                detectedLanguages: [
                    {
                        languageCode: 'en',
                        confidence: 1,
                    },
                ],
            },
            boundingBox: {
                normalizedVertices: [
                    {
                        x: 0.1764706,
                        y: 0.33650416,
                    },
                    {
                        x: 0.93109244,
                        y: 0.33650416,
                    },
                    {
                        x: 0.93109244,
                        y: 0.37693223,
                    },
                    {
                        x: 0.1764706,
                        y: 0.37693223,
                    },
                ],
            },
            paragraphs: [
                {
                    property: {
                        detectedLanguages: [
                            {
                                languageCode: 'en',
                                confidence: 1,
                            },
                        ],
                    },
                    boundingBox: {
                        normalizedVertices: [
                            {
                                x: 0.1764706,
                                y: 0.33650416,
                            },
                            {
                                x: 0.93109244,
                                y: 0.33650416,
                            },
                            {
                                x: 0.93109244,
                                y: 0.37693223,
                            },
                            {
                                x: 0.1764706,
                                y: 0.37693223,
                            },
                        ],
                    },
                    words: [
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.1764706,
                                        y: 0.33650416,
                                    },
                                    {
                                        x: 0.2,
                                        y: 0.33650416,
                                    },
                                    {
                                        x: 0.2,
                                        y: 0.34958383,
                                    },
                                    {
                                        x: 0.1764706,
                                        y: 0.34958383,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'T',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'h',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.20840336,
                                        y: 0.33650416,
                                    },
                                    {
                                        x: 0.26050422,
                                        y: 0.33650416,
                                    },
                                    {
                                        x: 0.26050422,
                                        y: 0.34958383,
                                    },
                                    {
                                        x: 0.20840336,
                                        y: 0.34958383,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'G',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'e',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'n',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'r',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'a',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'l',
                                    confidence: 0.99,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.26890758,
                                        y: 0.33650416,
                                    },
                                    {
                                        x: 0.30756304,
                                        y: 0.33650416,
                                    },
                                    {
                                        x: 0.30756304,
                                        y: 0.34958383,
                                    },
                                    {
                                        x: 0.26890758,
                                        y: 0.34958383,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'P',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'o',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'l',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'i',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'c',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'y',
                                    confidence: 0.97,
                                },
                            ],
                            confidence: 0.98,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.31428573,
                                        y: 0.33650416,
                                    },
                                    {
                                        x: 0.3882353,
                                        y: 0.33650416,
                                    },
                                    {
                                        x: 0.3882353,
                                        y: 0.34958383,
                                    },
                                    {
                                        x: 0.31428573,
                                        y: 0.34958383,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'C',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'o',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'n',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'd',
                                    confidence: 0.95,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'i',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 't',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'i',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'o',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'n',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 's',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.394958,
                                        y: 0.33650416,
                                    },
                                    {
                                        x: 0.41344538,
                                        y: 0.33650416,
                                    },
                                    {
                                        x: 0.41344538,
                                        y: 0.34958383,
                                    },
                                    {
                                        x: 0.394958,
                                        y: 0.34958383,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 's',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'e',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 't',
                                    confidence: 0.99,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.42016807,
                                        y: 0.33650416,
                                    },
                                    {
                                        x: 0.4420168,
                                        y: 0.33650416,
                                    },
                                    {
                                        x: 0.4420168,
                                        y: 0.34958383,
                                    },
                                    {
                                        x: 0.42016807,
                                        y: 0.34958383,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'o',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'u',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 't',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.4487395,
                                        y: 0.33650416,
                                    },
                                    {
                                        x: 0.46890756,
                                        y: 0.33650416,
                                    },
                                    {
                                        x: 0.46890756,
                                        y: 0.34958383,
                                    },
                                    {
                                        x: 0.4487395,
                                        y: 0.34958383,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 't',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'h',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                            ],
                            confidence: 1,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.47563025,
                                        y: 0.33650416,
                                    },
                                    {
                                        x: 0.5126051,
                                        y: 0.33650416,
                                    },
                                    {
                                        x: 0.5126051,
                                        y: 0.34958383,
                                    },
                                    {
                                        x: 0.47563025,
                                        y: 0.34958383,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'r',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'i',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'g',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'h',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 't',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 's',
                                    confidence: 0.99,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.52100843,
                                        y: 0.33650416,
                                    },
                                    {
                                        x: 0.54453784,
                                        y: 0.33650416,
                                    },
                                    {
                                        x: 0.54453784,
                                        y: 0.34958383,
                                    },
                                    {
                                        x: 0.52100843,
                                        y: 0.34958383,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'a',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'n',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'd',
                                    confidence: 1,
                                },
                            ],
                            confidence: 1,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.55126053,
                                        y: 0.33650416,
                                    },
                                    {
                                        x: 0.6252101,
                                        y: 0.33650416,
                                    },
                                    {
                                        x: 0.6252101,
                                        y: 0.34958383,
                                    },
                                    {
                                        x: 0.55126053,
                                        y: 0.34958383,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'o',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'b',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'l',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'i',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'g',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'a',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 't',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'i',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'o',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'n',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 's',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.6319328,
                                        y: 0.33650416,
                                    },
                                    {
                                        x: 0.702521,
                                        y: 0.33650416,
                                    },
                                    {
                                        x: 0.702521,
                                        y: 0.34958383,
                                    },
                                    {
                                        x: 0.6319328,
                                        y: 0.34958383,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'a',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'p',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'p',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'l',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'i',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'c',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'a',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'b',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'l',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.7092437,
                                        y: 0.33650416,
                                    },
                                    {
                                        x: 0.7210084,
                                        y: 0.33650416,
                                    },
                                    {
                                        x: 0.7210084,
                                        y: 0.34958383,
                                    },
                                    {
                                        x: 0.7092437,
                                        y: 0.34958383,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 't',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'o',
                                    confidence: 1,
                                },
                            ],
                            confidence: 1,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.7277311,
                                        y: 0.33650416,
                                    },
                                    {
                                        x: 0.7579832,
                                        y: 0.33650416,
                                    },
                                    {
                                        x: 0.7579832,
                                        y: 0.34958383,
                                    },
                                    {
                                        x: 0.7277311,
                                        y: 0.34958383,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'b',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'o',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 't',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'h',
                                    confidence: 0.99,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.7647059,
                                        y: 0.33650416,
                                    },
                                    {
                                        x: 0.7882353,
                                        y: 0.33650416,
                                    },
                                    {
                                        x: 0.7882353,
                                        y: 0.34958383,
                                    },
                                    {
                                        x: 0.7647059,
                                        y: 0.34958383,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'y',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'o',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'u',
                                    confidence: 0.99,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.794958,
                                        y: 0.33650416,
                                    },
                                    {
                                        x: 0.8184874,
                                        y: 0.33650416,
                                    },
                                    {
                                        x: 0.8184874,
                                        y: 0.34958383,
                                    },
                                    {
                                        x: 0.794958,
                                        y: 0.34958383,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'a',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'n',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'd',
                                    confidence: 1,
                                },
                            ],
                            confidence: 1,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.82689077,
                                        y: 0.33650416,
                                    },
                                    {
                                        x: 0.8420168,
                                        y: 0.33650416,
                                    },
                                    {
                                        x: 0.8420168,
                                        y: 0.34958383,
                                    },
                                    {
                                        x: 0.82689077,
                                        y: 0.34958383,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'u',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 's',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.8436975,
                                        y: 0.33650416,
                                    },
                                    {
                                        x: 0.84537816,
                                        y: 0.33650416,
                                    },
                                    {
                                        x: 0.84537816,
                                        y: 0.34958383,
                                    },
                                    {
                                        x: 0.8436975,
                                        y: 0.34958383,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: '.',
                                    confidence: 0.99,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.8537815,
                                        y: 0.33650416,
                                    },
                                    {
                                        x: 0.897479,
                                        y: 0.33650416,
                                    },
                                    {
                                        x: 0.897479,
                                        y: 0.34958383,
                                    },
                                    {
                                        x: 0.8537815,
                                        y: 0.34958383,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'P',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'l',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'e',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'a',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 's',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.9042017,
                                        y: 0.33650416,
                                    },
                                    {
                                        x: 0.93109244,
                                        y: 0.33650416,
                                    },
                                    {
                                        x: 0.93109244,
                                        y: 0.34958383,
                                    },
                                    {
                                        x: 0.9042017,
                                        y: 0.34958383,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'a',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'l',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 's',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'EOL_SURE_SPACE',
                                        },
                                    },
                                    text: 'o',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.1764706,
                                        y: 0.3507729,
                                    },
                                    {
                                        x: 0.2302521,
                                        y: 0.3507729,
                                    },
                                    {
                                        x: 0.2302521,
                                        y: 0.3626635,
                                    },
                                    {
                                        x: 0.1764706,
                                        y: 0.3626635,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'o',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'b',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 's',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'r',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'v',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'e',
                                    confidence: 0.99,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.23697479,
                                        y: 0.3507729,
                                    },
                                    {
                                        x: 0.26050422,
                                        y: 0.3507729,
                                    },
                                    {
                                        x: 0.26050422,
                                        y: 0.3626635,
                                    },
                                    {
                                        x: 0.23697479,
                                        y: 0.3626635,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'a',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'n',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'y',
                                    confidence: 0.99,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.2672269,
                                        y: 0.3507729,
                                    },
                                    {
                                        x: 0.33277312,
                                        y: 0.3507729,
                                    },
                                    {
                                        x: 0.33277312,
                                        y: 0.3626635,
                                    },
                                    {
                                        x: 0.2672269,
                                        y: 0.3626635,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'a',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'd',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'd',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'i',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 't',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'i',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'o',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'n',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'a',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'l',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.3394958,
                                        y: 0.3507729,
                                    },
                                    {
                                        x: 0.41008404,
                                        y: 0.3507729,
                                    },
                                    {
                                        x: 0.41008404,
                                        y: 0.3626635,
                                    },
                                    {
                                        x: 0.3394958,
                                        y: 0.3626635,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'c',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'o',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'n',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'd',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'i',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 't',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'i',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'o',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'n',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 's',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.41680673,
                                        y: 0.3507729,
                                    },
                                    {
                                        x: 0.42857143,
                                        y: 0.3507729,
                                    },
                                    {
                                        x: 0.42857143,
                                        y: 0.3626635,
                                    },
                                    {
                                        x: 0.41680673,
                                        y: 0.3626635,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'o',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'r',
                                    confidence: 0.99,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.43529412,
                                        y: 0.3507729,
                                    },
                                    {
                                        x: 0.48235294,
                                        y: 0.3507729,
                                    },
                                    {
                                        x: 0.48235294,
                                        y: 0.3626635,
                                    },
                                    {
                                        x: 0.43529412,
                                        y: 0.3626635,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 's',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'p',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'c',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'i',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'a',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'l',
                                    confidence: 0.99,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.48907563,
                                        y: 0.3507729,
                                    },
                                    {
                                        x: 0.5596639,
                                        y: 0.3507729,
                                    },
                                    {
                                        x: 0.5596639,
                                        y: 0.3626635,
                                    },
                                    {
                                        x: 0.48907563,
                                        y: 0.3626635,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'c',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'o',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'n',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'd',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'i',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 't',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'i',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'o',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'n',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 's',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.56134456,
                                        y: 0.3507729,
                                    },
                                    {
                                        x: 0.56302524,
                                        y: 0.3507729,
                                    },
                                    {
                                        x: 0.56302524,
                                        y: 0.3626635,
                                    },
                                    {
                                        x: 0.56134456,
                                        y: 0.3626635,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: '.',
                                    confidence: 0.98,
                                },
                            ],
                            confidence: 0.98,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.5697479,
                                        y: 0.3507729,
                                    },
                                    {
                                        x: 0.6,
                                        y: 0.3507729,
                                    },
                                    {
                                        x: 0.6,
                                        y: 0.3626635,
                                    },
                                    {
                                        x: 0.5697479,
                                        y: 0.3626635,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'Y',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'o',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'u',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'r',
                                    confidence: 0.99,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.6084034,
                                        y: 0.3507729,
                                    },
                                    {
                                        x: 0.6722689,
                                        y: 0.3507729,
                                    },
                                    {
                                        x: 0.6722689,
                                        y: 0.3626635,
                                    },
                                    {
                                        x: 0.6084034,
                                        y: 0.3626635,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'i',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'n',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 's',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'u',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'r',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'a',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'n',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'c',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.6789916,
                                        y: 0.3507729,
                                    },
                                    {
                                        x: 0.7344538,
                                        y: 0.3507729,
                                    },
                                    {
                                        x: 0.7344538,
                                        y: 0.3626635,
                                    },
                                    {
                                        x: 0.6789916,
                                        y: 0.3626635,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'c',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'o',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'n',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 't',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'r',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'a',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'c',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 't',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.74285716,
                                        y: 0.3507729,
                                    },
                                    {
                                        x: 0.7512605,
                                        y: 0.3507729,
                                    },
                                    {
                                        x: 0.7512605,
                                        y: 0.3626635,
                                    },
                                    {
                                        x: 0.74285716,
                                        y: 0.3626635,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'i',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 's',
                                    confidence: 0.99,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.7579832,
                                        y: 0.3507729,
                                    },
                                    {
                                        x: 0.78487396,
                                        y: 0.3507729,
                                    },
                                    {
                                        x: 0.78487396,
                                        y: 0.3626635,
                                    },
                                    {
                                        x: 0.7579832,
                                        y: 0.3626635,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'a',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'l',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 's',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'o',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.79159665,
                                        y: 0.3507729,
                                    },
                                    {
                                        x: 0.84033614,
                                        y: 0.3507729,
                                    },
                                    {
                                        x: 0.84033614,
                                        y: 0.3626635,
                                    },
                                    {
                                        x: 0.79159665,
                                        y: 0.3626635,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 's',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'u',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'b',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'j',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'c',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 't',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.84705883,
                                        y: 0.3507729,
                                    },
                                    {
                                        x: 0.85882354,
                                        y: 0.3507729,
                                    },
                                    {
                                        x: 0.85882354,
                                        y: 0.3626635,
                                    },
                                    {
                                        x: 0.84705883,
                                        y: 0.3626635,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 't',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'o',
                                    confidence: 1,
                                },
                            ],
                            confidence: 1,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.8655462,
                                        y: 0.3507729,
                                    },
                                    {
                                        x: 0.8857143,
                                        y: 0.3507729,
                                    },
                                    {
                                        x: 0.8857143,
                                        y: 0.3626635,
                                    },
                                    {
                                        x: 0.8655462,
                                        y: 0.3626635,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 't',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'h',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                            ],
                            confidence: 1,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.892437,
                                        y: 0.3507729,
                                    },
                                    {
                                        x: 0.93109244,
                                        y: 0.3507729,
                                    },
                                    {
                                        x: 0.93109244,
                                        y: 0.3626635,
                                    },
                                    {
                                        x: 0.892437,
                                        y: 0.3626635,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'S',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'w',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'i',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 's',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'EOL_SURE_SPACE',
                                        },
                                    },
                                    text: 's',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.17815126,
                                        y: 0.3650416,
                                    },
                                    {
                                        x: 0.24369748,
                                        y: 0.3650416,
                                    },
                                    {
                                        x: 0.24369748,
                                        y: 0.37693223,
                                    },
                                    {
                                        x: 0.17815126,
                                        y: 0.37693223,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'I',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'n',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 's',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'u',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'r',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'a',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'n',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'c',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.2487395,
                                        y: 0.3650416,
                                    },
                                    {
                                        x: 0.30084035,
                                        y: 0.3650416,
                                    },
                                    {
                                        x: 0.30084035,
                                        y: 0.37693223,
                                    },
                                    {
                                        x: 0.2487395,
                                        y: 0.37693223,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'P',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'o',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'l',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'i',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'c',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'i',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'e',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 's',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.3042017,
                                        y: 0.3650416,
                                    },
                                    {
                                        x: 0.3277311,
                                        y: 0.3650416,
                                    },
                                    {
                                        x: 0.3277311,
                                        y: 0.37693223,
                                    },
                                    {
                                        x: 0.3042017,
                                        y: 0.37693223,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'A',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'c',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 't',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.33277312,
                                        y: 0.3650416,
                                    },
                                    {
                                        x: 0.33613446,
                                        y: 0.3650416,
                                    },
                                    {
                                        x: 0.33613446,
                                        y: 0.37693223,
                                    },
                                    {
                                        x: 0.33277312,
                                        y: 0.37693223,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: '(',
                                    confidence: 0.99,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.33781514,
                                        y: 0.3650416,
                                    },
                                    {
                                        x: 0.36638656,
                                        y: 0.3650416,
                                    },
                                    {
                                        x: 0.36638656,
                                        y: 0.37693223,
                                    },
                                    {
                                        x: 0.33781514,
                                        y: 0.37693223,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'W',
                                    confidence: 0.84,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'V',
                                    confidence: 0.94,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'G',
                                    confidence: 0.97,
                                },
                            ],
                            confidence: 0.91,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.36806723,
                                        y: 0.3650416,
                                    },
                                    {
                                        x: 0.3697479,
                                        y: 0.3650416,
                                    },
                                    {
                                        x: 0.3697479,
                                        y: 0.37693223,
                                    },
                                    {
                                        x: 0.36806723,
                                        y: 0.37693223,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: ')',
                                    confidence: 0.89,
                                },
                            ],
                            confidence: 0.89,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.3764706,
                                        y: 0.3650416,
                                    },
                                    {
                                        x: 0.4,
                                        y: 0.3650416,
                                    },
                                    {
                                        x: 0.4,
                                        y: 0.37693223,
                                    },
                                    {
                                        x: 0.3764706,
                                        y: 0.37693223,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'a',
                                    confidence: 0.98,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'n',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'd',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.4067227,
                                        y: 0.3650416,
                                    },
                                    {
                                        x: 0.44537815,
                                        y: 0.3650416,
                                    },
                                    {
                                        x: 0.44537815,
                                        y: 0.37693223,
                                    },
                                    {
                                        x: 0.4067227,
                                        y: 0.37693223,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'S',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'w',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'i',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 's',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 's',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.45210084,
                                        y: 0.3650416,
                                    },
                                    {
                                        x: 0.4722689,
                                        y: 0.3650416,
                                    },
                                    {
                                        x: 0.4722689,
                                        y: 0.37693223,
                                    },
                                    {
                                        x: 0.45210084,
                                        y: 0.37693223,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'l',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'a',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'w',
                                    confidence: 0.99,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.47394958,
                                        y: 0.3650416,
                                    },
                                    {
                                        x: 0.47563025,
                                        y: 0.3650416,
                                    },
                                    {
                                        x: 0.47563025,
                                        y: 0.37693223,
                                    },
                                    {
                                        x: 0.47394958,
                                        y: 0.37693223,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'LINE_BREAK',
                                        },
                                    },
                                    text: '.',
                                    confidence: 0.99,
                                },
                            ],
                            confidence: 0.99,
                        },
                    ],
                    confidence: 0.99,
                },
            ],
            blockType: 'TEXT',
            confidence: 0.99,
        },
        {
            property: {
                detectedLanguages: [
                    {
                        languageCode: 'en',
                        confidence: 1,
                    },
                ],
            },
            boundingBox: {
                normalizedVertices: [
                    {
                        x: 0.1764706,
                        y: 0.39357907,
                    },
                    {
                        x: 0.93109244,
                        y: 0.39357907,
                    },
                    {
                        x: 0.93109244,
                        y: 0.48751485,
                    },
                    {
                        x: 0.1764706,
                        y: 0.48751485,
                    },
                ],
            },
            paragraphs: [
                {
                    property: {
                        detectedLanguages: [
                            {
                                languageCode: 'en',
                                confidence: 1,
                            },
                        ],
                    },
                    boundingBox: {
                        normalizedVertices: [
                            {
                                x: 0.1764706,
                                y: 0.39357907,
                            },
                            {
                                x: 0.93109244,
                                y: 0.39357907,
                            },
                            {
                                x: 0.93109244,
                                y: 0.46016645,
                            },
                            {
                                x: 0.1764706,
                                y: 0.46016645,
                            },
                        ],
                    },
                    words: [
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.1764706,
                                        y: 0.39357907,
                                    },
                                    {
                                        x: 0.23193277,
                                        y: 0.39357907,
                                    },
                                    {
                                        x: 0.23193277,
                                        y: 0.40309155,
                                    },
                                    {
                                        x: 0.1764706,
                                        y: 0.40309155,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'V',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'a',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'r',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'i',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'o',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'u',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 's',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.23697479,
                                        y: 0.39357907,
                                    },
                                    {
                                        x: 0.29915968,
                                        y: 0.39357907,
                                    },
                                    {
                                        x: 0.29915968,
                                        y: 0.40309155,
                                    },
                                    {
                                        x: 0.23697479,
                                        y: 0.40309155,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'm',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'o',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'd',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'u',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'l',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'EOL_SURE_SPACE',
                                        },
                                    },
                                    text: 's',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.1764706,
                                        y: 0.40665874,
                                    },
                                    {
                                        x: 0.23193277,
                                        y: 0.40665874,
                                    },
                                    {
                                        x: 0.23193277,
                                        y: 0.4197384,
                                    },
                                    {
                                        x: 0.1764706,
                                        y: 0.4197384,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'V',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'a',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'r',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'i',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'o',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'u',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 's',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.23529412,
                                        y: 0.40665874,
                                    },
                                    {
                                        x: 0.27563027,
                                        y: 0.40665874,
                                    },
                                    {
                                        x: 0.27563027,
                                        y: 0.4197384,
                                    },
                                    {
                                        x: 0.23529412,
                                        y: 0.4197384,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 't',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'y',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'p',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 's',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.28235295,
                                        y: 0.40665874,
                                    },
                                    {
                                        x: 0.29411766,
                                        y: 0.40665874,
                                    },
                                    {
                                        x: 0.29411766,
                                        y: 0.4197384,
                                    },
                                    {
                                        x: 0.28235295,
                                        y: 0.4197384,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'o',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'f',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.30084035,
                                        y: 0.40665874,
                                    },
                                    {
                                        x: 0.37142858,
                                        y: 0.40665874,
                                    },
                                    {
                                        x: 0.37142858,
                                        y: 0.4197384,
                                    },
                                    {
                                        x: 0.30084035,
                                        y: 0.4197384,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'i',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'n',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 's',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'u',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'r',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'a',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'n',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'c',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.37815127,
                                        y: 0.40665874,
                                    },
                                    {
                                        x: 0.4,
                                        y: 0.40665874,
                                    },
                                    {
                                        x: 0.4,
                                        y: 0.4197384,
                                    },
                                    {
                                        x: 0.37815127,
                                        y: 0.4197384,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'a',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'r',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'e',
                                    confidence: 0.99,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.4067227,
                                        y: 0.40665874,
                                    },
                                    {
                                        x: 0.44537815,
                                        y: 0.40665874,
                                    },
                                    {
                                        x: 0.44537815,
                                        y: 0.4197384,
                                    },
                                    {
                                        x: 0.4067227,
                                        y: 0.4197384,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'l',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'i',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 's',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 't',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'd',
                                    confidence: 0.99,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.45042017,
                                        y: 0.40665874,
                                    },
                                    {
                                        x: 0.46218488,
                                        y: 0.40665874,
                                    },
                                    {
                                        x: 0.46218488,
                                        y: 0.4197384,
                                    },
                                    {
                                        x: 0.45042017,
                                        y: 0.4197384,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'i',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'n',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.4672269,
                                        y: 0.40665874,
                                    },
                                    {
                                        x: 0.50756305,
                                        y: 0.40665874,
                                    },
                                    {
                                        x: 0.50756305,
                                        y: 0.4197384,
                                    },
                                    {
                                        x: 0.4672269,
                                        y: 0.4197384,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 't',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'h',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 's',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.5126051,
                                        y: 0.40665874,
                                    },
                                    {
                                        x: 0.54453784,
                                        y: 0.40665874,
                                    },
                                    {
                                        x: 0.54453784,
                                        y: 0.4197384,
                                    },
                                    {
                                        x: 0.5126051,
                                        y: 0.4197384,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'G',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'P',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'C',
                                    confidence: 0.99,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.5462185,
                                        y: 0.40665874,
                                    },
                                    {
                                        x: 0.54957986,
                                        y: 0.40665874,
                                    },
                                    {
                                        x: 0.54957986,
                                        y: 0.4197384,
                                    },
                                    {
                                        x: 0.5462185,
                                        y: 0.4197384,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: '.',
                                    confidence: 0.99,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.5546219,
                                        y: 0.40665874,
                                    },
                                    {
                                        x: 0.584874,
                                        y: 0.40665874,
                                    },
                                    {
                                        x: 0.584874,
                                        y: 0.4197384,
                                    },
                                    {
                                        x: 0.5546219,
                                        y: 0.4197384,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'W',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'h',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'y',
                                    confidence: 0.99,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.589916,
                                        y: 0.40665874,
                                    },
                                    {
                                        x: 0.6016807,
                                        y: 0.40665874,
                                    },
                                    {
                                        x: 0.6016807,
                                        y: 0.4197384,
                                    },
                                    {
                                        x: 0.589916,
                                        y: 0.4197384,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'i',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 's',
                                    confidence: 1,
                                },
                            ],
                            confidence: 1,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.6067227,
                                        y: 0.40665874,
                                    },
                                    {
                                        x: 0.63529414,
                                        y: 0.40665874,
                                    },
                                    {
                                        x: 0.63529414,
                                        y: 0.4197384,
                                    },
                                    {
                                        x: 0.6067227,
                                        y: 0.4197384,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 't',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'h',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'a',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 't',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.6369748,
                                        y: 0.40665874,
                                    },
                                    {
                                        x: 0.6436975,
                                        y: 0.40665874,
                                    },
                                    {
                                        x: 0.6436975,
                                        y: 0.4197384,
                                    },
                                    {
                                        x: 0.6369748,
                                        y: 0.4197384,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'EOL_SURE_SPACE',
                                        },
                                    },
                                    text: '?',
                                    confidence: 0.99,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.1764706,
                                        y: 0.42211652,
                                    },
                                    {
                                        x: 0.20168068,
                                        y: 0.42211652,
                                    },
                                    {
                                        x: 0.20168068,
                                        y: 0.43400714,
                                    },
                                    {
                                        x: 0.1764706,
                                        y: 0.43400714,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'O',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'u',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'r',
                                    confidence: 0.99,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.20672269,
                                        y: 0.42211652,
                                    },
                                    {
                                        x: 0.2420168,
                                        y: 0.42211652,
                                    },
                                    {
                                        x: 0.2420168,
                                        y: 0.43400714,
                                    },
                                    {
                                        x: 0.20672269,
                                        y: 0.43400714,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 't',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'r',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'a',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'v',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'l',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.2487395,
                                        y: 0.42211652,
                                    },
                                    {
                                        x: 0.31428573,
                                        y: 0.42211652,
                                    },
                                    {
                                        x: 0.31428573,
                                        y: 0.43400714,
                                    },
                                    {
                                        x: 0.2487395,
                                        y: 0.43400714,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'i',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'n',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 's',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'u',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'r',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'a',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'n',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'c',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.3210084,
                                        y: 0.42211652,
                                    },
                                    {
                                        x: 0.32941177,
                                        y: 0.42211652,
                                    },
                                    {
                                        x: 0.32941177,
                                        y: 0.43400714,
                                    },
                                    {
                                        x: 0.3210084,
                                        y: 0.43400714,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'i',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 's',
                                    confidence: 0.99,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.3344538,
                                        y: 0.42211652,
                                    },
                                    {
                                        x: 0.40336135,
                                        y: 0.42211652,
                                    },
                                    {
                                        x: 0.40336135,
                                        y: 0.43400714,
                                    },
                                    {
                                        x: 0.3344538,
                                        y: 0.43400714,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 's',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 't',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'r',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'u',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'c',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 't',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'u',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'r',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'd',
                                    confidence: 0.99,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.41008404,
                                        y: 0.42211652,
                                    },
                                    {
                                        x: 0.42016807,
                                        y: 0.42211652,
                                    },
                                    {
                                        x: 0.42016807,
                                        y: 0.43400714,
                                    },
                                    {
                                        x: 0.41008404,
                                        y: 0.43400714,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'i',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'n',
                                    confidence: 1,
                                },
                            ],
                            confidence: 1,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.42689076,
                                        y: 0.42211652,
                                    },
                                    {
                                        x: 0.4840336,
                                        y: 0.42211652,
                                    },
                                    {
                                        x: 0.4840336,
                                        y: 0.43400714,
                                    },
                                    {
                                        x: 0.42689076,
                                        y: 0.43400714,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'm',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'o',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'd',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'u',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'l',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'e',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 's',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.4857143,
                                        y: 0.42211652,
                                    },
                                    {
                                        x: 0.48739496,
                                        y: 0.42211652,
                                    },
                                    {
                                        x: 0.48739496,
                                        y: 0.43400714,
                                    },
                                    {
                                        x: 0.4857143,
                                        y: 0.43400714,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: '.',
                                    confidence: 0.98,
                                },
                            ],
                            confidence: 0.98,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.49411765,
                                        y: 0.42211652,
                                    },
                                    {
                                        x: 0.52100843,
                                        y: 0.42211652,
                                    },
                                    {
                                        x: 0.52100843,
                                        y: 0.43400714,
                                    },
                                    {
                                        x: 0.49411765,
                                        y: 0.43400714,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'T',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'h',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'i',
                                    confidence: 0.98,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 's',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.5277311,
                                        y: 0.42211652,
                                    },
                                    {
                                        x: 0.5714286,
                                        y: 0.42211652,
                                    },
                                    {
                                        x: 0.5714286,
                                        y: 0.43400714,
                                    },
                                    {
                                        x: 0.5277311,
                                        y: 0.43400714,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'm',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'a',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'n',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 's',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.5764706,
                                        y: 0.42211652,
                                    },
                                    {
                                        x: 0.6016807,
                                        y: 0.42211652,
                                    },
                                    {
                                        x: 0.6016807,
                                        y: 0.43400714,
                                    },
                                    {
                                        x: 0.5764706,
                                        y: 0.43400714,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 't',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'h',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'a',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 't',
                                    confidence: 1,
                                },
                            ],
                            confidence: 1,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.6084034,
                                        y: 0.42211652,
                                    },
                                    {
                                        x: 0.6302521,
                                        y: 0.42211652,
                                    },
                                    {
                                        x: 0.6302521,
                                        y: 0.43400714,
                                    },
                                    {
                                        x: 0.6084034,
                                        y: 0.43400714,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'y',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'o',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'u',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.6369748,
                                        y: 0.42211652,
                                    },
                                    {
                                        x: 0.6605042,
                                        y: 0.42211652,
                                    },
                                    {
                                        x: 0.6605042,
                                        y: 0.43400714,
                                    },
                                    {
                                        x: 0.6369748,
                                        y: 0.43400714,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'c',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'a',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'n',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.6672269,
                                        y: 0.42211652,
                                    },
                                    {
                                        x: 0.69411767,
                                        y: 0.42211652,
                                    },
                                    {
                                        x: 0.69411767,
                                        y: 0.43400714,
                                    },
                                    {
                                        x: 0.6672269,
                                        y: 0.43400714,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 't',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'a',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'k',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.70084035,
                                        y: 0.42211652,
                                    },
                                    {
                                        x: 0.7210084,
                                        y: 0.42211652,
                                    },
                                    {
                                        x: 0.7210084,
                                        y: 0.43400714,
                                    },
                                    {
                                        x: 0.70084035,
                                        y: 0.43400714,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'o',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'u',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 't',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.72605044,
                                        y: 0.42211652,
                                    },
                                    {
                                        x: 0.7831933,
                                        y: 0.42211652,
                                    },
                                    {
                                        x: 0.7831933,
                                        y: 0.43400714,
                                    },
                                    {
                                        x: 0.72605044,
                                        y: 0.43400714,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'd',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'i',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'f',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'f',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'r',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'n',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 't',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.7882353,
                                        y: 0.42211652,
                                    },
                                    {
                                        x: 0.8252101,
                                        y: 0.42211652,
                                    },
                                    {
                                        x: 0.8252101,
                                        y: 0.43400714,
                                    },
                                    {
                                        x: 0.7882353,
                                        y: 0.43400714,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 't',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'y',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'p',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 's',
                                    confidence: 1,
                                },
                            ],
                            confidence: 1,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.8302521,
                                        y: 0.42211652,
                                    },
                                    {
                                        x: 0.8436975,
                                        y: 0.42211652,
                                    },
                                    {
                                        x: 0.8436975,
                                        y: 0.43400714,
                                    },
                                    {
                                        x: 0.8302521,
                                        y: 0.43400714,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'o',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'f',
                                    confidence: 0.98,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.8487395,
                                        y: 0.42211652,
                                    },
                                    {
                                        x: 0.9142857,
                                        y: 0.42211652,
                                    },
                                    {
                                        x: 0.9142857,
                                        y: 0.43400714,
                                    },
                                    {
                                        x: 0.8487395,
                                        y: 0.43400714,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'i',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'n',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 's',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'u',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'r',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'a',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'n',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'c',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.91932774,
                                        y: 0.42211652,
                                    },
                                    {
                                        x: 0.93109244,
                                        y: 0.42211652,
                                    },
                                    {
                                        x: 0.93109244,
                                        y: 0.43400714,
                                    },
                                    {
                                        x: 0.91932774,
                                        y: 0.43400714,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'a',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'EOL_SURE_SPACE',
                                        },
                                    },
                                    text: 't',
                                    confidence: 0.99,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.1764706,
                                        y: 0.4351962,
                                    },
                                    {
                                        x: 0.19663866,
                                        y: 0.4351962,
                                    },
                                    {
                                        x: 0.19663866,
                                        y: 0.44827586,
                                    },
                                    {
                                        x: 0.1764706,
                                        y: 0.44827586,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 't',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'h',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.20336135,
                                        y: 0.4351962,
                                    },
                                    {
                                        x: 0.23865546,
                                        y: 0.4351962,
                                    },
                                    {
                                        x: 0.23865546,
                                        y: 0.44827586,
                                    },
                                    {
                                        x: 0.20336135,
                                        y: 0.44827586,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 's',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'a',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'm',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.24369748,
                                        y: 0.4351962,
                                    },
                                    {
                                        x: 0.27226892,
                                        y: 0.4351962,
                                    },
                                    {
                                        x: 0.27226892,
                                        y: 0.44827586,
                                    },
                                    {
                                        x: 0.24369748,
                                        y: 0.44827586,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 't',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'i',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'm',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                            ],
                            confidence: 1,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.2739496,
                                        y: 0.4351962,
                                    },
                                    {
                                        x: 0.27563027,
                                        y: 0.4351962,
                                    },
                                    {
                                        x: 0.27563027,
                                        y: 0.44827586,
                                    },
                                    {
                                        x: 0.2739496,
                                        y: 0.44827586,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: '.',
                                    confidence: 0.99,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.28067228,
                                        y: 0.4351962,
                                    },
                                    {
                                        x: 0.3226891,
                                        y: 0.4351962,
                                    },
                                    {
                                        x: 0.3226891,
                                        y: 0.44827586,
                                    },
                                    {
                                        x: 0.28067228,
                                        y: 0.44827586,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'T',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'h',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 's',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.3277311,
                                        y: 0.4351962,
                                    },
                                    {
                                        x: 0.34789917,
                                        y: 0.4351962,
                                    },
                                    {
                                        x: 0.34789917,
                                        y: 0.44827586,
                                    },
                                    {
                                        x: 0.3277311,
                                        y: 0.44827586,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'a',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'r',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                            ],
                            confidence: 1,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.3529412,
                                        y: 0.4351962,
                                    },
                                    {
                                        x: 0.36638656,
                                        y: 0.4351962,
                                    },
                                    {
                                        x: 0.36638656,
                                        y: 0.44827586,
                                    },
                                    {
                                        x: 0.3529412,
                                        y: 0.44827586,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'a',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'l',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'l',
                                    confidence: 0.99,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.37310925,
                                        y: 0.4351962,
                                    },
                                    {
                                        x: 0.42016807,
                                        y: 0.4351962,
                                    },
                                    {
                                        x: 0.42016807,
                                        y: 0.44827586,
                                    },
                                    {
                                        x: 0.37310925,
                                        y: 0.44827586,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'i',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'n',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 's',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'u',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'r',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'e',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'd',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.42857143,
                                        y: 0.4351962,
                                    },
                                    {
                                        x: 0.46554622,
                                        y: 0.4351962,
                                    },
                                    {
                                        x: 0.46554622,
                                        y: 0.44827586,
                                    },
                                    {
                                        x: 0.42857143,
                                        y: 0.44827586,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'u',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'n',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'd',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'r',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.47058824,
                                        y: 0.4351962,
                                    },
                                    {
                                        x: 0.4907563,
                                        y: 0.4351962,
                                    },
                                    {
                                        x: 0.4907563,
                                        y: 0.44827586,
                                    },
                                    {
                                        x: 0.47058824,
                                        y: 0.44827586,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 't',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'h',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.497479,
                                        y: 0.4351962,
                                    },
                                    {
                                        x: 0.53277314,
                                        y: 0.4351962,
                                    },
                                    {
                                        x: 0.53277314,
                                        y: 0.44827586,
                                    },
                                    {
                                        x: 0.497479,
                                        y: 0.44827586,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 's',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'a',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'm',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.53781515,
                                        y: 0.4351962,
                                    },
                                    {
                                        x: 0.59327734,
                                        y: 0.4351962,
                                    },
                                    {
                                        x: 0.59327734,
                                        y: 0.44827586,
                                    },
                                    {
                                        x: 0.53781515,
                                        y: 0.44827586,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'c',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'o',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'n',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 't',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'r',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'a',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'c',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 't',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.5966387,
                                        y: 0.4351962,
                                    },
                                    {
                                        x: 0.59831935,
                                        y: 0.4351962,
                                    },
                                    {
                                        x: 0.59831935,
                                        y: 0.44827586,
                                    },
                                    {
                                        x: 0.5966387,
                                        y: 0.44827586,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: '.',
                                    confidence: 0.99,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.60336137,
                                        y: 0.4351962,
                                    },
                                    {
                                        x: 0.62857145,
                                        y: 0.4351962,
                                    },
                                    {
                                        x: 0.62857145,
                                        y: 0.44827586,
                                    },
                                    {
                                        x: 0.60336137,
                                        y: 0.44827586,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'T',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'h',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.63361347,
                                        y: 0.4351962,
                                    },
                                    {
                                        x: 0.692437,
                                        y: 0.4351962,
                                    },
                                    {
                                        x: 0.692437,
                                        y: 0.44827586,
                                    },
                                    {
                                        x: 0.63361347,
                                        y: 0.44827586,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'f',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'o',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'l',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'l',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'o',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'w',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'i',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'n',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'g',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.6991597,
                                        y: 0.4351962,
                                    },
                                    {
                                        x: 0.75630254,
                                        y: 0.4351962,
                                    },
                                    {
                                        x: 0.75630254,
                                        y: 0.44827586,
                                    },
                                    {
                                        x: 0.6991597,
                                        y: 0.44827586,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'm',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'o',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'd',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'u',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'l',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 's',
                                    confidence: 0.99,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.76134455,
                                        y: 0.4351962,
                                    },
                                    {
                                        x: 0.7815126,
                                        y: 0.4351962,
                                    },
                                    {
                                        x: 0.7815126,
                                        y: 0.44827586,
                                    },
                                    {
                                        x: 0.76134455,
                                        y: 0.44827586,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'a',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'r',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.78655463,
                                        y: 0.4351962,
                                    },
                                    {
                                        x: 0.84537816,
                                        y: 0.4351962,
                                    },
                                    {
                                        x: 0.84537816,
                                        y: 0.44827586,
                                    },
                                    {
                                        x: 0.78655463,
                                        y: 0.44827586,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'a',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'v',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'a',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'i',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'l',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'a',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'b',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'l',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.8504202,
                                        y: 0.4351962,
                                    },
                                    {
                                        x: 0.88907564,
                                        y: 0.4351962,
                                    },
                                    {
                                        x: 0.88907564,
                                        y: 0.44827586,
                                    },
                                    {
                                        x: 0.8504202,
                                        y: 0.44827586,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'w',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'i',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 't',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'h',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'i',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'n',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.8957983,
                                        y: 0.4351962,
                                    },
                                    {
                                        x: 0.93109244,
                                        y: 0.4351962,
                                    },
                                    {
                                        x: 0.93109244,
                                        y: 0.44827586,
                                    },
                                    {
                                        x: 0.8957983,
                                        y: 0.44827586,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 't',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'r',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'a',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'v',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'EOL_SURE_SPACE',
                                        },
                                    },
                                    text: 'l',
                                    confidence: 0.99,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.17815126,
                                        y: 0.45065397,
                                    },
                                    {
                                        x: 0.2420168,
                                        y: 0.45065397,
                                    },
                                    {
                                        x: 0.2420168,
                                        y: 0.46016645,
                                    },
                                    {
                                        x: 0.17815126,
                                        y: 0.46016645,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'i',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'n',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 's',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'u',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'r',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'a',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'n',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'c',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.24369748,
                                        y: 0.45065397,
                                    },
                                    {
                                        x: 0.24537815,
                                        y: 0.45065397,
                                    },
                                    {
                                        x: 0.24537815,
                                        y: 0.46016645,
                                    },
                                    {
                                        x: 0.24369748,
                                        y: 0.46016645,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'LINE_BREAK',
                                        },
                                    },
                                    text: ':',
                                    confidence: 0.96,
                                },
                            ],
                            confidence: 0.96,
                        },
                    ],
                    confidence: 0.99,
                },
                {
                    property: {
                        detectedLanguages: [
                            {
                                languageCode: 'en',
                                confidence: 1,
                            },
                        ],
                    },
                    boundingBox: {
                        normalizedVertices: [
                            {
                                x: 0.5109244,
                                y: 0.4625446,
                            },
                            {
                                x: 0.6016807,
                                y: 0.4625446,
                            },
                            {
                                x: 0.6016807,
                                y: 0.4744352,
                            },
                            {
                                x: 0.5109244,
                                y: 0.4744352,
                            },
                        ],
                    },
                    words: [
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.5109244,
                                        y: 0.4625446,
                                    },
                                    {
                                        x: 0.6016807,
                                        y: 0.4625446,
                                    },
                                    {
                                        x: 0.6016807,
                                        y: 0.4744352,
                                    },
                                    {
                                        x: 0.5109244,
                                        y: 0.4744352,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'C',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'a',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'n',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'c',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'l',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'l',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'a',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 't',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'i',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'o',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'LINE_BREAK',
                                        },
                                    },
                                    text: 'n',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                    ],
                    confidence: 0.99,
                },
                {
                    property: {
                        detectedLanguages: [
                            {
                                languageCode: 'en',
                                confidence: 1,
                            },
                        ],
                    },
                    boundingBox: {
                        normalizedVertices: [
                            {
                                x: 0.5361345,
                                y: 0.46611178,
                            },
                            {
                                x: 0.8235294,
                                y: 0.46611178,
                            },
                            {
                                x: 0.8235294,
                                y: 0.48751485,
                            },
                            {
                                x: 0.5361345,
                                y: 0.48751485,
                            },
                        ],
                    },
                    words: [
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.74453783,
                                        y: 0.46611178,
                                    },
                                    {
                                        x: 0.77310926,
                                        y: 0.46611178,
                                    },
                                    {
                                        x: 0.77310926,
                                        y: 0.4744352,
                                    },
                                    {
                                        x: 0.74453783,
                                        y: 0.4744352,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'B',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'a',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 's',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'i',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'c',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.7781513,
                                        y: 0.46611178,
                                    },
                                    {
                                        x: 0.8235294,
                                        y: 0.46611178,
                                    },
                                    {
                                        x: 0.8235294,
                                        y: 0.4744352,
                                    },
                                    {
                                        x: 0.7781513,
                                        y: 0.4744352,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'm',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'o',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'd',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'u',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'l',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'EOL_SURE_SPACE',
                                        },
                                    },
                                    text: 's',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.5361345,
                                        y: 0.47800237,
                                    },
                                    {
                                        x: 0.5764706,
                                        y: 0.47919145,
                                    },
                                    {
                                        x: 0.5764706,
                                        y: 0.48751485,
                                    },
                                    {
                                        x: 0.5361345,
                                        y: 0.4863258,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'c',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'o',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 's',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 't',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'LINE_BREAK',
                                        },
                                    },
                                    text: 's',
                                    confidence: 0.99,
                                },
                            ],
                            confidence: 0.99,
                        },
                    ],
                    confidence: 0.99,
                },
                {
                    property: {
                        detectedLanguages: [
                            {
                                languageCode: 'en',
                                confidence: 1,
                            },
                        ],
                    },
                    boundingBox: {
                        normalizedVertices: [
                            {
                                x: 0.74453783,
                                y: 0.47800237,
                            },
                            {
                                x: 0.87563026,
                                y: 0.47800237,
                            },
                            {
                                x: 0.87563026,
                                y: 0.48751485,
                            },
                            {
                                x: 0.74453783,
                                y: 0.48751485,
                            },
                        ],
                    },
                    words: [
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.74453783,
                                        y: 0.47800237,
                                    },
                                    {
                                        x: 0.8252101,
                                        y: 0.47800237,
                                    },
                                    {
                                        x: 0.8252101,
                                        y: 0.48751485,
                                    },
                                    {
                                        x: 0.74453783,
                                        y: 0.48751485,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'S',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'u',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'p',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'p',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'l',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'm',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'n',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 't',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'a',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'r',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'y',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.8302521,
                                        y: 0.47800237,
                                    },
                                    {
                                        x: 0.87563026,
                                        y: 0.47681332,
                                    },
                                    {
                                        x: 0.87563026,
                                        y: 0.4863258,
                                    },
                                    {
                                        x: 0.8302521,
                                        y: 0.48751485,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'm',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'o',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'd',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'u',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'l',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'LINE_BREAK',
                                        },
                                    },
                                    text: 's',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                    ],
                    confidence: 0.99,
                },
            ],
            blockType: 'TEXT',
            confidence: 0.99,
        },
        {
            property: {
                detectedLanguages: [
                    {
                        languageCode: 'en',
                        confidence: 1,
                    },
                ],
            },
            boundingBox: {
                normalizedVertices: [
                    {
                        x: 0.21344538,
                        y: 0.58501786,
                    },
                    {
                        x: 0.31932774,
                        y: 0.58501786,
                    },
                    {
                        x: 0.31932774,
                        y: 0.627824,
                    },
                    {
                        x: 0.21344538,
                        y: 0.627824,
                    },
                ],
            },
            paragraphs: [
                {
                    property: {
                        detectedLanguages: [
                            {
                                languageCode: 'en',
                                confidence: 1,
                            },
                        ],
                    },
                    boundingBox: {
                        normalizedVertices: [
                            {
                                x: 0.21344538,
                                y: 0.58501786,
                            },
                            {
                                x: 0.31932774,
                                y: 0.58501786,
                            },
                            {
                                x: 0.31932774,
                                y: 0.627824,
                            },
                            {
                                x: 0.21344538,
                                y: 0.627824,
                            },
                        ],
                    },
                    words: [
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.21344538,
                                        y: 0.58501786,
                                    },
                                    {
                                        x: 0.30084035,
                                        y: 0.58501786,
                                    },
                                    {
                                        x: 0.30084035,
                                        y: 0.59690845,
                                    },
                                    {
                                        x: 0.21344538,
                                        y: 0.59690845,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'A',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 's',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 's',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'u',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'm',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'p',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 't',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'i',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'o',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'n',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.30588236,
                                        y: 0.58501786,
                                    },
                                    {
                                        x: 0.31932774,
                                        y: 0.58501786,
                                    },
                                    {
                                        x: 0.31932774,
                                        y: 0.59690845,
                                    },
                                    {
                                        x: 0.30588236,
                                        y: 0.59690845,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'o',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'EOL_SURE_SPACE',
                                        },
                                    },
                                    text: 'f',
                                    confidence: 0.98,
                                },
                            ],
                            confidence: 0.98,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.21512605,
                                        y: 0.59928656,
                                    },
                                    {
                                        x: 0.292437,
                                        y: 0.59928656,
                                    },
                                    {
                                        x: 0.292437,
                                        y: 0.61117715,
                                    },
                                    {
                                        x: 0.21512605,
                                        y: 0.61117715,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'd',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'd',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'u',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'c',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 't',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'i',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'b',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'l',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'e',
                                    confidence: 0.99,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.297479,
                                        y: 0.59928656,
                                    },
                                    {
                                        x: 0.31764707,
                                        y: 0.59928656,
                                    },
                                    {
                                        x: 0.31764707,
                                        y: 0.61117715,
                                    },
                                    {
                                        x: 0.297479,
                                        y: 0.61117715,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'f',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'o',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'EOL_SURE_SPACE',
                                        },
                                    },
                                    text: 'r',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.21344538,
                                        y: 0.6135553,
                                    },
                                    {
                                        x: 0.25378153,
                                        y: 0.6135553,
                                    },
                                    {
                                        x: 0.25378153,
                                        y: 0.627824,
                                    },
                                    {
                                        x: 0.21344538,
                                        y: 0.627824,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'r',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'n',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 't',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'a',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'l',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.26050422,
                                        y: 0.6135553,
                                    },
                                    {
                                        x: 0.31932774,
                                        y: 0.6135553,
                                    },
                                    {
                                        x: 0.31932774,
                                        y: 0.627824,
                                    },
                                    {
                                        x: 0.26050422,
                                        y: 0.627824,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'v',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'h',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'i',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'c',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'l',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'LINE_BREAK',
                                        },
                                    },
                                    text: 's',
                                    confidence: 0.99,
                                },
                            ],
                            confidence: 0.99,
                        },
                    ],
                    confidence: 0.99,
                },
            ],
            blockType: 'TEXT',
            confidence: 0.99,
        },
        {
            boundingBox: {
                normalizedVertices: [
                    {
                        x: 0.38655463,
                        y: 0.5909631,
                    },
                    {
                        x: 0.43865547,
                        y: 0.5909631,
                    },
                    {
                        x: 0.43865547,
                        y: 0.6171225,
                    },
                    {
                        x: 0.38655463,
                        y: 0.6171225,
                    },
                ],
            },
            paragraphs: [
                {
                    boundingBox: {
                        normalizedVertices: [
                            {
                                x: 0.38655463,
                                y: 0.5909631,
                            },
                            {
                                x: 0.43865547,
                                y: 0.5909631,
                            },
                            {
                                x: 0.43865547,
                                y: 0.6171225,
                            },
                            {
                                x: 0.38655463,
                                y: 0.6171225,
                            },
                        ],
                    },
                    words: [
                        {
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.38655463,
                                        y: 0.5909631,
                                    },
                                    {
                                        x: 0.43865547,
                                        y: 0.5909631,
                                    },
                                    {
                                        x: 0.43865547,
                                        y: 0.6171225,
                                    },
                                    {
                                        x: 0.38655463,
                                        y: 0.6171225,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedBreak: {
                                            type: 'LINE_BREAK',
                                        },
                                    },
                                    text: 'A',
                                    confidence: 0.35,
                                },
                            ],
                            confidence: 0.35,
                        },
                    ],
                    confidence: 0.35,
                },
            ],
            blockType: 'TEXT',
            confidence: 0.35,
        },
        {
            property: {
                detectedLanguages: [
                    {
                        languageCode: 'en',
                        confidence: 1,
                    },
                ],
            },
            boundingBox: {
                normalizedVertices: [
                    {
                        x: 0.79831934,
                        y: 0.5909631,
                    },
                    {
                        x: 0.87563026,
                        y: 0.5909631,
                    },
                    {
                        x: 0.87563026,
                        y: 0.6159334,
                    },
                    {
                        x: 0.79831934,
                        y: 0.6159334,
                    },
                ],
            },
            paragraphs: [
                {
                    property: {
                        detectedLanguages: [
                            {
                                languageCode: 'en',
                                confidence: 1,
                            },
                        ],
                    },
                    boundingBox: {
                        normalizedVertices: [
                            {
                                x: 0.79831934,
                                y: 0.5909631,
                            },
                            {
                                x: 0.87563026,
                                y: 0.5909631,
                            },
                            {
                                x: 0.87563026,
                                y: 0.6159334,
                            },
                            {
                                x: 0.79831934,
                                y: 0.6159334,
                            },
                        ],
                    },
                    words: [
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.805042,
                                        y: 0.5909631,
                                    },
                                    {
                                        x: 0.8689076,
                                        y: 0.5909631,
                                    },
                                    {
                                        x: 0.8689076,
                                        y: 0.6040428,
                                    },
                                    {
                                        x: 0.805042,
                                        y: 0.6040428,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'P',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'e',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'r',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 's',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'o',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'n',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'a',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'EOL_SURE_SPACE',
                                        },
                                    },
                                    text: 'l',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.79831934,
                                        y: 0.60761,
                                    },
                                    {
                                        x: 0.87563026,
                                        y: 0.60761,
                                    },
                                    {
                                        x: 0.87563026,
                                        y: 0.6159334,
                                    },
                                    {
                                        x: 0.79831934,
                                        y: 0.6159334,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'a',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 's',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 's',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'i',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 's',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 't',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'a',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'n',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'c',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'LINE_BREAK',
                                        },
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                    ],
                    confidence: 0.99,
                },
            ],
            blockType: 'TEXT',
            confidence: 0.99,
        },
        {
            property: {
                detectedLanguages: [
                    {
                        languageCode: 'en',
                        confidence: 1,
                    },
                ],
            },
            boundingBox: {
                normalizedVertices: [
                    {
                        x: 0.5226891,
                        y: 0.6848989,
                    },
                    {
                        x: 0.59327734,
                        y: 0.6848989,
                    },
                    {
                        x: 0.59327734,
                        y: 0.70630205,
                    },
                    {
                        x: 0.5226891,
                        y: 0.70630205,
                    },
                ],
            },
            paragraphs: [
                {
                    property: {
                        detectedLanguages: [
                            {
                                languageCode: 'en',
                                confidence: 1,
                            },
                        ],
                    },
                    boundingBox: {
                        normalizedVertices: [
                            {
                                x: 0.5226891,
                                y: 0.6848989,
                            },
                            {
                                x: 0.59327734,
                                y: 0.6848989,
                            },
                            {
                                x: 0.59327734,
                                y: 0.70630205,
                            },
                            {
                                x: 0.5226891,
                                y: 0.70630205,
                            },
                        ],
                    },
                    words: [
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.5361345,
                                        y: 0.6848989,
                                    },
                                    {
                                        x: 0.57983196,
                                        y: 0.6848989,
                                    },
                                    {
                                        x: 0.57983196,
                                        y: 0.69322234,
                                    },
                                    {
                                        x: 0.5361345,
                                        y: 0.69322234,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'T',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'r',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'a',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'v',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'EOL_SURE_SPACE',
                                        },
                                    },
                                    text: 'l',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.5226891,
                                        y: 0.6979786,
                                    },
                                    {
                                        x: 0.59327734,
                                        y: 0.6979786,
                                    },
                                    {
                                        x: 0.59327734,
                                        y: 0.70630205,
                                    },
                                    {
                                        x: 0.5226891,
                                        y: 0.70630205,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'i',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'n',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 's',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'u',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'r',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'a',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'n',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'c',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'LINE_BREAK',
                                        },
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                    ],
                    confidence: 0.99,
                },
            ],
            blockType: 'TEXT',
            confidence: 0.99,
        },
        {
            property: {
                detectedLanguages: [
                    {
                        languageCode: 'en',
                        confidence: 1,
                    },
                ],
            },
            boundingBox: {
                normalizedVertices: [
                    {
                        x: 0.2487395,
                        y: 0.72057074,
                    },
                    {
                        x: 0.31260505,
                        y: 0.72057074,
                    },
                    {
                        x: 0.31260505,
                        y: 0.73246133,
                    },
                    {
                        x: 0.2487395,
                        y: 0.73246133,
                    },
                ],
            },
            paragraphs: [
                {
                    property: {
                        detectedLanguages: [
                            {
                                languageCode: 'en',
                                confidence: 1,
                            },
                        ],
                    },
                    boundingBox: {
                        normalizedVertices: [
                            {
                                x: 0.2487395,
                                y: 0.72057074,
                            },
                            {
                                x: 0.31260505,
                                y: 0.72057074,
                            },
                            {
                                x: 0.31260505,
                                y: 0.73246133,
                            },
                            {
                                x: 0.2487395,
                                y: 0.73246133,
                            },
                        ],
                    },
                    words: [
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.2487395,
                                        y: 0.72057074,
                                    },
                                    {
                                        x: 0.31260505,
                                        y: 0.72057074,
                                    },
                                    {
                                        x: 0.31260505,
                                        y: 0.73246133,
                                    },
                                    {
                                        x: 0.2487395,
                                        y: 0.73246133,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'L',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'u',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'g',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'g',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'a',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'g',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'LINE_BREAK',
                                        },
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                    ],
                    confidence: 0.99,
                },
            ],
            blockType: 'TEXT',
            confidence: 0.99,
        },
        {
            property: {
                detectedLanguages: [
                    {
                        languageCode: 'en',
                        confidence: 1,
                    },
                ],
            },
            boundingBox: {
                normalizedVertices: [
                    {
                        x: 0.79831934,
                        y: 0.71343637,
                    },
                    {
                        x: 0.87731093,
                        y: 0.71343637,
                    },
                    {
                        x: 0.87731093,
                        y: 0.73602855,
                    },
                    {
                        x: 0.79831934,
                        y: 0.73602855,
                    },
                ],
            },
            paragraphs: [
                {
                    property: {
                        detectedLanguages: [
                            {
                                languageCode: 'en',
                                confidence: 1,
                            },
                        ],
                    },
                    boundingBox: {
                        normalizedVertices: [
                            {
                                x: 0.79831934,
                                y: 0.71343637,
                            },
                            {
                                x: 0.87731093,
                                y: 0.71343637,
                            },
                            {
                                x: 0.87731093,
                                y: 0.73602855,
                            },
                            {
                                x: 0.79831934,
                                y: 0.73602855,
                            },
                        ],
                    },
                    words: [
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.8117647,
                                        y: 0.71343637,
                                    },
                                    {
                                        x: 0.8621849,
                                        y: 0.71343637,
                                    },
                                    {
                                        x: 0.8621849,
                                        y: 0.7217598,
                                    },
                                    {
                                        x: 0.8117647,
                                        y: 0.7217598,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'V',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'e',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'h',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'i',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'c',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'l',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'EOL_SURE_SPACE',
                                        },
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.79831934,
                                        y: 0.7277051,
                                    },
                                    {
                                        x: 0.87731093,
                                        y: 0.7277051,
                                    },
                                    {
                                        x: 0.87731093,
                                        y: 0.73602855,
                                    },
                                    {
                                        x: 0.79831934,
                                        y: 0.73602855,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'a',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 's',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 's',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'i',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 's',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 't',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'a',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'n',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'c',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'LINE_BREAK',
                                        },
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                    ],
                    confidence: 0.99,
                },
            ],
            blockType: 'TEXT',
            confidence: 0.99,
        },
        {
            boundingBox: {
                normalizedVertices: [
                    {
                        x: 0.59831935,
                        y: 0.7764566,
                    },
                    {
                        x: 0.6,
                        y: 0.79548156,
                    },
                    {
                        x: 0.5109244,
                        y: 0.80023783,
                    },
                    {
                        x: 0.5092437,
                        y: 0.78121287,
                    },
                ],
            },
            paragraphs: [
                {
                    boundingBox: {
                        normalizedVertices: [
                            {
                                x: 0.59831935,
                                y: 0.7764566,
                            },
                            {
                                x: 0.6,
                                y: 0.79548156,
                            },
                            {
                                x: 0.5109244,
                                y: 0.80023783,
                            },
                            {
                                x: 0.5092437,
                                y: 0.78121287,
                            },
                        ],
                    },
                    words: [
                        {
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.59831935,
                                        y: 0.7764566,
                                    },
                                    {
                                        x: 0.6,
                                        y: 0.79548156,
                                    },
                                    {
                                        x: 0.5109244,
                                        y: 0.80023783,
                                    },
                                    {
                                        x: 0.5092437,
                                        y: 0.78121287,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedBreak: {
                                            type: 'LINE_BREAK',
                                        },
                                    },
                                    text: '\u5206',
                                    confidence: 0.9,
                                },
                            ],
                            confidence: 0.9,
                        },
                    ],
                    confidence: 0.9,
                },
            ],
            blockType: 'TEXT',
            confidence: 0.9,
        },
        {
            boundingBox: {
                normalizedVertices: [
                    {
                        x: 0.55630255,
                        y: 0.8109394,
                    },
                    {
                        x: 0.5596639,
                        y: 0.76337695,
                    },
                    {
                        x: 0.5781513,
                        y: 0.764566,
                    },
                    {
                        x: 0.57478994,
                        y: 0.8109394,
                    },
                ],
            },
            paragraphs: [
                {
                    boundingBox: {
                        normalizedVertices: [
                            {
                                x: 0.55630255,
                                y: 0.8109394,
                            },
                            {
                                x: 0.5596639,
                                y: 0.76337695,
                            },
                            {
                                x: 0.5781513,
                                y: 0.764566,
                            },
                            {
                                x: 0.57478994,
                                y: 0.8109394,
                            },
                        ],
                    },
                    words: [
                        {
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.55630255,
                                        y: 0.8109394,
                                    },
                                    {
                                        x: 0.5596639,
                                        y: 0.76337695,
                                    },
                                    {
                                        x: 0.5781513,
                                        y: 0.764566,
                                    },
                                    {
                                        x: 0.57478994,
                                        y: 0.8109394,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedBreak: {
                                            type: 'LINE_BREAK',
                                        },
                                    },
                                    text: '\ub09c',
                                    confidence: 0.97,
                                },
                            ],
                            confidence: 0.97,
                        },
                    ],
                    confidence: 0.97,
                },
            ],
            blockType: 'TEXT',
            confidence: 0.97,
        },
        {
            property: {
                detectedLanguages: [
                    {
                        languageCode: 'en',
                        confidence: 1,
                    },
                ],
            },
            boundingBox: {
                normalizedVertices: [
                    {
                        x: 0.4789916,
                        y: 0.8359096,
                    },
                    {
                        x: 0.6319328,
                        y: 0.8359096,
                    },
                    {
                        x: 0.6319328,
                        y: 0.86206895,
                    },
                    {
                        x: 0.4789916,
                        y: 0.86206895,
                    },
                ],
            },
            paragraphs: [
                {
                    property: {
                        detectedLanguages: [
                            {
                                languageCode: 'en',
                                confidence: 1,
                            },
                        ],
                    },
                    boundingBox: {
                        normalizedVertices: [
                            {
                                x: 0.4789916,
                                y: 0.8359096,
                            },
                            {
                                x: 0.6319328,
                                y: 0.8359096,
                            },
                            {
                                x: 0.6319328,
                                y: 0.8454221,
                            },
                            {
                                x: 0.4789916,
                                y: 0.8454221,
                            },
                        ],
                    },
                    words: [
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.4789916,
                                        y: 0.8359096,
                                    },
                                    {
                                        x: 0.5226891,
                                        y: 0.8359096,
                                    },
                                    {
                                        x: 0.5226891,
                                        y: 0.8454221,
                                    },
                                    {
                                        x: 0.4789916,
                                        y: 0.8454221,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'T',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'r',
                                    confidence: 0.97,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'a',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'v',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'l',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.5277311,
                                        y: 0.8359096,
                                    },
                                    {
                                        x: 0.5529412,
                                        y: 0.8359096,
                                    },
                                    {
                                        x: 0.5529412,
                                        y: 0.8454221,
                                    },
                                    {
                                        x: 0.5277311,
                                        y: 0.8454221,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'a',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'n',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'd',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.5596639,
                                        y: 0.8359096,
                                    },
                                    {
                                        x: 0.62857145,
                                        y: 0.8359096,
                                    },
                                    {
                                        x: 0.62857145,
                                        y: 0.8454221,
                                    },
                                    {
                                        x: 0.5596639,
                                        y: 0.8454221,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'm',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'o',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 't',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'o',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'r',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'i',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 's',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 't',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 's',
                                    confidence: 0.99,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.6319328,
                                        y: 0.8359096,
                                    },
                                    {
                                        x: 0.6319328,
                                        y: 0.8359096,
                                    },
                                    {
                                        x: 0.6319328,
                                        y: 0.8454221,
                                    },
                                    {
                                        x: 0.6319328,
                                        y: 0.8454221,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'LINE_BREAK',
                                        },
                                    },
                                    text: "'",
                                    confidence: 0.94,
                                },
                            ],
                            confidence: 0.94,
                        },
                    ],
                    confidence: 0.99,
                },
                {
                    property: {
                        detectedLanguages: [
                            {
                                languageCode: 'en',
                                confidence: 1,
                            },
                        ],
                    },
                    boundingBox: {
                        normalizedVertices: [
                            {
                                x: 0.49915966,
                                y: 0.85017836,
                            },
                            {
                                x: 0.6134454,
                                y: 0.85017836,
                            },
                            {
                                x: 0.6134454,
                                y: 0.86206895,
                            },
                            {
                                x: 0.49915966,
                                y: 0.86206895,
                            },
                        ],
                    },
                    words: [
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.49915966,
                                        y: 0.85017836,
                                    },
                                    {
                                        x: 0.53277314,
                                        y: 0.85017836,
                                    },
                                    {
                                        x: 0.53277314,
                                        y: 0.86206895,
                                    },
                                    {
                                        x: 0.49915966,
                                        y: 0.86206895,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'l',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'g',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'a',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'l',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.5394958,
                                        y: 0.85017836,
                                    },
                                    {
                                        x: 0.6134454,
                                        y: 0.85017836,
                                    },
                                    {
                                        x: 0.6134454,
                                        y: 0.86206895,
                                    },
                                    {
                                        x: 0.5394958,
                                        y: 0.86206895,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'p',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'r',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'o',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 't',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'c',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 't',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'i',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'o',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'LINE_BREAK',
                                        },
                                    },
                                    text: 'n',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                    ],
                    confidence: 0.99,
                },
            ],
            blockType: 'TEXT',
            confidence: 0.99,
        },
        {
            property: {
                detectedLanguages: [
                    {
                        languageCode: 'en',
                        confidence: 1,
                    },
                ],
            },
            boundingBox: {
                normalizedVertices: [
                    {
                        x: 0.1764706,
                        y: 0.8763377,
                    },
                    {
                        x: 0.93109244,
                        y: 0.8763377,
                    },
                    {
                        x: 0.93109244,
                        y: 0.90487516,
                    },
                    {
                        x: 0.1764706,
                        y: 0.90487516,
                    },
                ],
            },
            paragraphs: [
                {
                    property: {
                        detectedLanguages: [
                            {
                                languageCode: 'en',
                                confidence: 1,
                            },
                        ],
                    },
                    boundingBox: {
                        normalizedVertices: [
                            {
                                x: 0.1764706,
                                y: 0.8763377,
                            },
                            {
                                x: 0.93109244,
                                y: 0.8763377,
                            },
                            {
                                x: 0.93109244,
                                y: 0.90487516,
                            },
                            {
                                x: 0.1764706,
                                y: 0.90487516,
                            },
                        ],
                    },
                    words: [
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.17815126,
                                        y: 0.8763377,
                                    },
                                    {
                                        x: 0.18487395,
                                        y: 0.8763377,
                                    },
                                    {
                                        x: 0.18487395,
                                        y: 0.8906064,
                                    },
                                    {
                                        x: 0.17815126,
                                        y: 0.8906064,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'I',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 't',
                                    confidence: 0.99,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.18991597,
                                        y: 0.8763377,
                                    },
                                    {
                                        x: 0.21680672,
                                        y: 0.8763377,
                                    },
                                    {
                                        x: 0.21680672,
                                        y: 0.8906064,
                                    },
                                    {
                                        x: 0.18991597,
                                        y: 0.8906064,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'm',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'a',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'y',
                                    confidence: 0.99,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.22184874,
                                        y: 0.8763377,
                                    },
                                    {
                                        x: 0.23697479,
                                        y: 0.8763377,
                                    },
                                    {
                                        x: 0.23697479,
                                        y: 0.8906064,
                                    },
                                    {
                                        x: 0.22184874,
                                        y: 0.8906064,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'b',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                            ],
                            confidence: 1,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.2420168,
                                        y: 0.8763377,
                                    },
                                    {
                                        x: 0.2672269,
                                        y: 0.8763377,
                                    },
                                    {
                                        x: 0.2672269,
                                        y: 0.8906064,
                                    },
                                    {
                                        x: 0.2420168,
                                        y: 0.8906064,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 't',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'h',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'a',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 't',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.27226892,
                                        y: 0.8763377,
                                    },
                                    {
                                        x: 0.29411766,
                                        y: 0.8763377,
                                    },
                                    {
                                        x: 0.29411766,
                                        y: 0.8906064,
                                    },
                                    {
                                        x: 0.27226892,
                                        y: 0.8906064,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'y',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'o',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'u',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.30084035,
                                        y: 0.8763377,
                                    },
                                    {
                                        x: 0.33109245,
                                        y: 0.8763377,
                                    },
                                    {
                                        x: 0.33109245,
                                        y: 0.8906064,
                                    },
                                    {
                                        x: 0.30084035,
                                        y: 0.8906064,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'h',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'a',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'v',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.3344538,
                                        y: 0.8763377,
                                    },
                                    {
                                        x: 0.36302522,
                                        y: 0.8763377,
                                    },
                                    {
                                        x: 0.36302522,
                                        y: 0.8906064,
                                    },
                                    {
                                        x: 0.3344538,
                                        y: 0.8906064,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'o',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'n',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'l',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'y',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.36638656,
                                        y: 0.8763377,
                                    },
                                    {
                                        x: 0.40336135,
                                        y: 0.8763377,
                                    },
                                    {
                                        x: 0.40336135,
                                        y: 0.8906064,
                                    },
                                    {
                                        x: 0.36638656,
                                        y: 0.8906064,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 't',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'a',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'k',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'n',
                                    confidence: 0.98,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.40840337,
                                        y: 0.8763377,
                                    },
                                    {
                                        x: 0.42857143,
                                        y: 0.8763377,
                                    },
                                    {
                                        x: 0.42857143,
                                        y: 0.8906064,
                                    },
                                    {
                                        x: 0.40840337,
                                        y: 0.8906064,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'o',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'u',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 't',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.43361345,
                                        y: 0.8763377,
                                    },
                                    {
                                        x: 0.47058824,
                                        y: 0.8763377,
                                    },
                                    {
                                        x: 0.47058824,
                                        y: 0.8906064,
                                    },
                                    {
                                        x: 0.43361345,
                                        y: 0.8906064,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 's',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'o',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'm',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.47563025,
                                        y: 0.8763377,
                                    },
                                    {
                                        x: 0.48739496,
                                        y: 0.8763377,
                                    },
                                    {
                                        x: 0.48739496,
                                        y: 0.8906064,
                                    },
                                    {
                                        x: 0.47563025,
                                        y: 0.8906064,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'o',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'f',
                                    confidence: 1,
                                },
                            ],
                            confidence: 1,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.49243698,
                                        y: 0.8763377,
                                    },
                                    {
                                        x: 0.5126051,
                                        y: 0.8763377,
                                    },
                                    {
                                        x: 0.5126051,
                                        y: 0.8906064,
                                    },
                                    {
                                        x: 0.49243698,
                                        y: 0.8906064,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 't',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'h',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.5176471,
                                        y: 0.8763377,
                                    },
                                    {
                                        x: 0.57478994,
                                        y: 0.8763377,
                                    },
                                    {
                                        x: 0.57478994,
                                        y: 0.8906064,
                                    },
                                    {
                                        x: 0.5176471,
                                        y: 0.8906064,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'm',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'o',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'd',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'u',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'l',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 's',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.5764706,
                                        y: 0.8763377,
                                    },
                                    {
                                        x: 0.5781513,
                                        y: 0.8763377,
                                    },
                                    {
                                        x: 0.5781513,
                                        y: 0.8906064,
                                    },
                                    {
                                        x: 0.5764706,
                                        y: 0.8906064,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: '.',
                                    confidence: 0.99,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.5831933,
                                        y: 0.8763377,
                                    },
                                    {
                                        x: 0.6084034,
                                        y: 0.8763377,
                                    },
                                    {
                                        x: 0.6084034,
                                        y: 0.8906064,
                                    },
                                    {
                                        x: 0.5831933,
                                        y: 0.8906064,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'Y',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'o',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'u',
                                    confidence: 0.99,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.6134454,
                                        y: 0.8763377,
                                    },
                                    {
                                        x: 0.63361347,
                                        y: 0.8763377,
                                    },
                                    {
                                        x: 0.63361347,
                                        y: 0.8906064,
                                    },
                                    {
                                        x: 0.6134454,
                                        y: 0.8906064,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'a',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'r',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.6386555,
                                        y: 0.8763377,
                                    },
                                    {
                                        x: 0.66554624,
                                        y: 0.8763377,
                                    },
                                    {
                                        x: 0.66554624,
                                        y: 0.8906064,
                                    },
                                    {
                                        x: 0.6386555,
                                        y: 0.8906064,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'o',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'n',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'l',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'y',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.6689076,
                                        y: 0.8763377,
                                    },
                                    {
                                        x: 0.7176471,
                                        y: 0.8763377,
                                    },
                                    {
                                        x: 0.7176471,
                                        y: 0.8906064,
                                    },
                                    {
                                        x: 0.6689076,
                                        y: 0.8906064,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 's',
                                    confidence: 0.98,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'u',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'b',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'j',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'c',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 't',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.7226891,
                                        y: 0.8763377,
                                    },
                                    {
                                        x: 0.7344538,
                                        y: 0.8763377,
                                    },
                                    {
                                        x: 0.7344538,
                                        y: 0.8906064,
                                    },
                                    {
                                        x: 0.7226891,
                                        y: 0.8906064,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 't',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'o',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.7394958,
                                        y: 0.8763377,
                                    },
                                    {
                                        x: 0.7596639,
                                        y: 0.8763377,
                                    },
                                    {
                                        x: 0.7596639,
                                        y: 0.8906064,
                                    },
                                    {
                                        x: 0.7394958,
                                        y: 0.8906064,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 't',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'h',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                            ],
                            confidence: 1,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.7647059,
                                        y: 0.8763377,
                                    },
                                    {
                                        x: 0.8352941,
                                        y: 0.8763377,
                                    },
                                    {
                                        x: 0.8352941,
                                        y: 0.8906064,
                                    },
                                    {
                                        x: 0.7647059,
                                        y: 0.8906064,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'c',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'o',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'n',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'd',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'i',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 't',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'i',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'o',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'n',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 's',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.84033614,
                                        y: 0.8763377,
                                    },
                                    {
                                        x: 0.85210085,
                                        y: 0.8763377,
                                    },
                                    {
                                        x: 0.85210085,
                                        y: 0.8906064,
                                    },
                                    {
                                        x: 0.84033614,
                                        y: 0.8906064,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'o',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'f',
                                    confidence: 0.99,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.85714287,
                                        y: 0.8763377,
                                    },
                                    {
                                        x: 0.87731093,
                                        y: 0.8763377,
                                    },
                                    {
                                        x: 0.87731093,
                                        y: 0.8906064,
                                    },
                                    {
                                        x: 0.85714287,
                                        y: 0.8906064,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 't',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'h',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.88235295,
                                        y: 0.8763377,
                                    },
                                    {
                                        x: 0.93109244,
                                        y: 0.8763377,
                                    },
                                    {
                                        x: 0.93109244,
                                        y: 0.8906064,
                                    },
                                    {
                                        x: 0.88235295,
                                        y: 0.8906064,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'm',
                                    confidence: 0.98,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'o',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'd',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'u',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'l',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'EOL_SURE_SPACE',
                                        },
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.1764706,
                                        y: 0.89298457,
                                    },
                                    {
                                        x: 0.20168068,
                                        y: 0.89298457,
                                    },
                                    {
                                        x: 0.20168068,
                                        y: 0.90487516,
                                    },
                                    {
                                        x: 0.1764706,
                                        y: 0.90487516,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 't',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'h',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'a',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 't',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.20672269,
                                        y: 0.89298457,
                                    },
                                    {
                                        x: 0.2302521,
                                        y: 0.89298457,
                                    },
                                    {
                                        x: 0.2302521,
                                        y: 0.90487516,
                                    },
                                    {
                                        x: 0.20672269,
                                        y: 0.90487516,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'y',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'o',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'u',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.23697479,
                                        y: 0.89298457,
                                    },
                                    {
                                        x: 0.2672269,
                                        y: 0.89298457,
                                    },
                                    {
                                        x: 0.2672269,
                                        y: 0.90487516,
                                    },
                                    {
                                        x: 0.23697479,
                                        y: 0.90487516,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'h',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'a',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'v',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.27226892,
                                        y: 0.89298457,
                                    },
                                    {
                                        x: 0.3092437,
                                        y: 0.89298457,
                                    },
                                    {
                                        x: 0.3092437,
                                        y: 0.90487516,
                                    },
                                    {
                                        x: 0.27226892,
                                        y: 0.90487516,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 't',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'a',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'k',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'n',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.31428573,
                                        y: 0.89298457,
                                    },
                                    {
                                        x: 0.3344538,
                                        y: 0.89298457,
                                    },
                                    {
                                        x: 0.3344538,
                                        y: 0.90487516,
                                    },
                                    {
                                        x: 0.31428573,
                                        y: 0.90487516,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'o',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'u',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 't',
                                    confidence: 0.99,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.33781514,
                                        y: 0.89298457,
                                    },
                                    {
                                        x: 0.3394958,
                                        y: 0.89298457,
                                    },
                                    {
                                        x: 0.3394958,
                                        y: 0.90487516,
                                    },
                                    {
                                        x: 0.33781514,
                                        y: 0.90487516,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: '.',
                                    confidence: 0.97,
                                },
                            ],
                            confidence: 0.97,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.34453782,
                                        y: 0.89298457,
                                    },
                                    {
                                        x: 0.3697479,
                                        y: 0.89298457,
                                    },
                                    {
                                        x: 0.3697479,
                                        y: 0.90487516,
                                    },
                                    {
                                        x: 0.34453782,
                                        y: 0.90487516,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'Y',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'o',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'u',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.3764706,
                                        y: 0.89298457,
                                    },
                                    {
                                        x: 0.40168068,
                                        y: 0.89298457,
                                    },
                                    {
                                        x: 0.40168068,
                                        y: 0.90487516,
                                    },
                                    {
                                        x: 0.3764706,
                                        y: 0.90487516,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'm',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'a',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'y',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.40840337,
                                        y: 0.89298457,
                                    },
                                    {
                                        x: 0.47058824,
                                        y: 0.89298457,
                                    },
                                    {
                                        x: 0.47058824,
                                        y: 0.90487516,
                                    },
                                    {
                                        x: 0.40840337,
                                        y: 0.90487516,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'd',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'i',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 's',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'r',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'e',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'g',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'a',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'r',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'd',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.47731093,
                                        y: 0.89298457,
                                    },
                                    {
                                        x: 0.497479,
                                        y: 0.89298457,
                                    },
                                    {
                                        x: 0.497479,
                                        y: 0.90487516,
                                    },
                                    {
                                        x: 0.47731093,
                                        y: 0.90487516,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 't',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'h',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.50252104,
                                        y: 0.89298457,
                                    },
                                    {
                                        x: 0.54453784,
                                        y: 0.89298457,
                                    },
                                    {
                                        x: 0.54453784,
                                        y: 0.90487516,
                                    },
                                    {
                                        x: 0.50252104,
                                        y: 0.90487516,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'o',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 't',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'h',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'r',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 's',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.5462185,
                                        y: 0.89298457,
                                    },
                                    {
                                        x: 0.5478992,
                                        y: 0.89298457,
                                    },
                                    {
                                        x: 0.5478992,
                                        y: 0.90487516,
                                    },
                                    {
                                        x: 0.5462185,
                                        y: 0.90487516,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'LINE_BREAK',
                                        },
                                    },
                                    text: '.',
                                    confidence: 0.99,
                                },
                            ],
                            confidence: 0.99,
                        },
                    ],
                    confidence: 0.99,
                },
            ],
            blockType: 'TEXT',
            confidence: 0.99,
        },
        {
            property: {
                detectedLanguages: [
                    {
                        languageCode: 'en',
                        confidence: 1,
                    },
                ],
            },
            boundingBox: {
                normalizedVertices: [
                    {
                        x: 0.1764706,
                        y: 0.9476813,
                    },
                    {
                        x: 0.88235295,
                        y: 0.9476813,
                    },
                    {
                        x: 0.88235295,
                        y: 0.9750297,
                    },
                    {
                        x: 0.1764706,
                        y: 0.9750297,
                    },
                ],
            },
            paragraphs: [
                {
                    property: {
                        detectedLanguages: [
                            {
                                languageCode: 'en',
                                confidence: 1,
                            },
                        ],
                    },
                    boundingBox: {
                        normalizedVertices: [
                            {
                                x: 0.1764706,
                                y: 0.9476813,
                            },
                            {
                                x: 0.88235295,
                                y: 0.9476813,
                            },
                            {
                                x: 0.88235295,
                                y: 0.9750297,
                            },
                            {
                                x: 0.1764706,
                                y: 0.9750297,
                            },
                        ],
                    },
                    words: [
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.1764706,
                                        y: 0.9476813,
                                    },
                                    {
                                        x: 0.2184874,
                                        y: 0.9476813,
                                    },
                                    {
                                        x: 0.2184874,
                                        y: 0.9548157,
                                    },
                                    {
                                        x: 0.1764706,
                                        y: 0.9548157,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'G',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'e',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'n',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'r',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'a',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'l',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'i',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.22352941,
                                        y: 0.9476813,
                                    },
                                    {
                                        x: 0.2621849,
                                        y: 0.9476813,
                                    },
                                    {
                                        x: 0.2621849,
                                        y: 0.9548157,
                                    },
                                    {
                                        x: 0.22352941,
                                        y: 0.9548157,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'G',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'e',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'n',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'r',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'a',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'l',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.2672269,
                                        y: 0.9476813,
                                    },
                                    {
                                        x: 0.31764707,
                                        y: 0.9476813,
                                    },
                                    {
                                        x: 0.31764707,
                                        y: 0.9548157,
                                    },
                                    {
                                        x: 0.2672269,
                                        y: 0.9548157,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'I',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'n',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 's',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'u',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'r',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'a',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'n',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'c',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.3210084,
                                        y: 0.9476813,
                                    },
                                    {
                                        x: 0.3394958,
                                        y: 0.9476813,
                                    },
                                    {
                                        x: 0.3394958,
                                        y: 0.9548157,
                                    },
                                    {
                                        x: 0.3210084,
                                        y: 0.9548157,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'L',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 't',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'd',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'EOL_SURE_SPACE',
                                        },
                                    },
                                    text: '.',
                                    confidence: 0.99,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.1764706,
                                        y: 0.95600474,
                                    },
                                    {
                                        x: 0.18319328,
                                        y: 0.95600474,
                                    },
                                    {
                                        x: 0.18319328,
                                        y: 0.9655172,
                                    },
                                    {
                                        x: 0.1764706,
                                        y: 0.9655172,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'A',
                                    confidence: 0.99,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.18655463,
                                        y: 0.95600474,
                                    },
                                    {
                                        x: 0.22689076,
                                        y: 0.95600474,
                                    },
                                    {
                                        x: 0.22689076,
                                        y: 0.9655172,
                                    },
                                    {
                                        x: 0.18655463,
                                        y: 0.9655172,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'm',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'm',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'b',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'r',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.2302521,
                                        y: 0.95600474,
                                    },
                                    {
                                        x: 0.23865546,
                                        y: 0.95600474,
                                    },
                                    {
                                        x: 0.23865546,
                                        y: 0.9655172,
                                    },
                                    {
                                        x: 0.2302521,
                                        y: 0.9655172,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'o',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'f',
                                    confidence: 1,
                                },
                            ],
                            confidence: 1,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.2420168,
                                        y: 0.95600474,
                                    },
                                    {
                                        x: 0.25714287,
                                        y: 0.95600474,
                                    },
                                    {
                                        x: 0.25714287,
                                        y: 0.9655172,
                                    },
                                    {
                                        x: 0.2420168,
                                        y: 0.9655172,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 't',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'h',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                            ],
                            confidence: 1,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.2621849,
                                        y: 0.95600474,
                                    },
                                    {
                                        x: 0.297479,
                                        y: 0.95600474,
                                    },
                                    {
                                        x: 0.297479,
                                        y: 0.9655172,
                                    },
                                    {
                                        x: 0.2621849,
                                        y: 0.9655172,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'G',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'r',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'u',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'p',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'p',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'o',
                                    confidence: 0.99,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.30084035,
                                        y: 0.95600474,
                                    },
                                    {
                                        x: 0.35966387,
                                        y: 0.95600474,
                                    },
                                    {
                                        x: 0.35966387,
                                        y: 0.9655172,
                                    },
                                    {
                                        x: 0.30084035,
                                        y: 0.9655172,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'A',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 's',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 's',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'i',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'c',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'u',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'r',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'a',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 't',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'i',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'v',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'o',
                                    confidence: 0.99,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.3647059,
                                        y: 0.95600474,
                                    },
                                    {
                                        x: 0.40336135,
                                        y: 0.95600474,
                                    },
                                    {
                                        x: 0.40336135,
                                        y: 0.9655172,
                                    },
                                    {
                                        x: 0.3647059,
                                        y: 0.9655172,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'G',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'e',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'n',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'r',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'a',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'l',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'i',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.40336135,
                                        y: 0.95600474,
                                    },
                                    {
                                        x: 0.4067227,
                                        y: 0.95600474,
                                    },
                                    {
                                        x: 0.4067227,
                                        y: 0.9655172,
                                    },
                                    {
                                        x: 0.40336135,
                                        y: 0.9655172,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: ',',
                                    confidence: 0.97,
                                },
                            ],
                            confidence: 0.97,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.41008404,
                                        y: 0.95600474,
                                    },
                                    {
                                        x: 0.44537815,
                                        y: 0.95600474,
                                    },
                                    {
                                        x: 0.44537815,
                                        y: 0.9655172,
                                    },
                                    {
                                        x: 0.41008404,
                                        y: 0.9655172,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'e',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'n',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 't',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'e',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'r',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'e',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'd',
                                    confidence: 0.99,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.45042017,
                                        y: 0.95600474,
                                    },
                                    {
                                        x: 0.45714286,
                                        y: 0.95600474,
                                    },
                                    {
                                        x: 0.45714286,
                                        y: 0.9655172,
                                    },
                                    {
                                        x: 0.45042017,
                                        y: 0.9655172,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'i',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'n',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.46218488,
                                        y: 0.95600474,
                                    },
                                    {
                                        x: 0.47563025,
                                        y: 0.95600474,
                                    },
                                    {
                                        x: 0.47563025,
                                        y: 0.9655172,
                                    },
                                    {
                                        x: 0.46218488,
                                        y: 0.9655172,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 't',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'h',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                            ],
                            confidence: 1,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.48067227,
                                        y: 0.95600474,
                                    },
                                    {
                                        x: 0.50756305,
                                        y: 0.95600474,
                                    },
                                    {
                                        x: 0.50756305,
                                        y: 0.9655172,
                                    },
                                    {
                                        x: 0.48067227,
                                        y: 0.9655172,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'I',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 't',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'a',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'l',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'i',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'a',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'n',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.5126051,
                                        y: 0.95600474,
                                    },
                                    {
                                        x: 0.5529412,
                                        y: 0.95600474,
                                    },
                                    {
                                        x: 0.5529412,
                                        y: 0.9655172,
                                    },
                                    {
                                        x: 0.5126051,
                                        y: 0.9655172,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'R',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'g',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'i',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 's',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 't',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'e',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'r',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.55630255,
                                        y: 0.95600474,
                                    },
                                    {
                                        x: 0.5647059,
                                        y: 0.95600474,
                                    },
                                    {
                                        x: 0.5647059,
                                        y: 0.9655172,
                                    },
                                    {
                                        x: 0.55630255,
                                        y: 0.9655172,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'o',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'f',
                                    confidence: 0.99,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.5697479,
                                        y: 0.95600474,
                                    },
                                    {
                                        x: 0.6151261,
                                        y: 0.95600474,
                                    },
                                    {
                                        x: 0.6151261,
                                        y: 0.9655172,
                                    },
                                    {
                                        x: 0.5697479,
                                        y: 0.9655172,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'I',
                                    confidence: 0.91,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'n',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 's',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'u',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'r',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'a',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'n',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'c',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.98,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.6201681,
                                        y: 0.95600474,
                                    },
                                    {
                                        x: 0.6739496,
                                        y: 0.95600474,
                                    },
                                    {
                                        x: 0.6739496,
                                        y: 0.9655172,
                                    },
                                    {
                                        x: 0.6201681,
                                        y: 0.9655172,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'C',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'o',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'm',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'p',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'a',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'n',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'i',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 's',
                                    confidence: 1,
                                },
                            ],
                            confidence: 1,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.67731094,
                                        y: 0.95600474,
                                    },
                                    {
                                        x: 0.7058824,
                                        y: 0.95600474,
                                    },
                                    {
                                        x: 0.7058824,
                                        y: 0.9655172,
                                    },
                                    {
                                        x: 0.67731094,
                                        y: 0.9655172,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'u',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'n',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'd',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'r',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.7092437,
                                        y: 0.95600474,
                                    },
                                    {
                                        x: 0.7462185,
                                        y: 0.95600474,
                                    },
                                    {
                                        x: 0.7462185,
                                        y: 0.9655172,
                                    },
                                    {
                                        x: 0.7092437,
                                        y: 0.9655172,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'n',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'u',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'm',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'b',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'r',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.74957985,
                                        y: 0.95600474,
                                    },
                                    {
                                        x: 0.7647059,
                                        y: 0.95600474,
                                    },
                                    {
                                        x: 0.7647059,
                                        y: 0.9655172,
                                    },
                                    {
                                        x: 0.74957985,
                                        y: 0.9655172,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: '0',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: '2',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: '6',
                                    confidence: 0.91,
                                },
                            ],
                            confidence: 0.96,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.76806724,
                                        y: 0.95600474,
                                    },
                                    {
                                        x: 0.7697479,
                                        y: 0.95600474,
                                    },
                                    {
                                        x: 0.7697479,
                                        y: 0.9655172,
                                    },
                                    {
                                        x: 0.76806724,
                                        y: 0.9655172,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'EOL_SURE_SPACE',
                                        },
                                    },
                                    text: '.',
                                    confidence: 0.97,
                                },
                            ],
                            confidence: 0.97,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.1764706,
                                        y: 0.9655172,
                                    },
                                    {
                                        x: 0.19327731,
                                        y: 0.9655172,
                                    },
                                    {
                                        x: 0.19327731,
                                        y: 0.9750297,
                                    },
                                    {
                                        x: 0.1764706,
                                        y: 0.9750297,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'O',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'u',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'r',
                                    confidence: 0.99,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.19831933,
                                        y: 0.9655172,
                                    },
                                    {
                                        x: 0.2184874,
                                        y: 0.9655172,
                                    },
                                    {
                                        x: 0.2184874,
                                        y: 0.9750297,
                                    },
                                    {
                                        x: 0.19831933,
                                        y: 0.9750297,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'd',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'a',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 't',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'a',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.22352941,
                                        y: 0.9655172,
                                    },
                                    {
                                        x: 0.27058825,
                                        y: 0.9655172,
                                    },
                                    {
                                        x: 0.27058825,
                                        y: 0.9750297,
                                    },
                                    {
                                        x: 0.22352941,
                                        y: 0.9750297,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'p',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'r',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'o',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 't',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'c',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 't',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'i',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'o',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'n',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.27563027,
                                        y: 0.9655172,
                                    },
                                    {
                                        x: 0.3226891,
                                        y: 0.9655172,
                                    },
                                    {
                                        x: 0.3226891,
                                        y: 0.9750297,
                                    },
                                    {
                                        x: 0.27563027,
                                        y: 0.9750297,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'p',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'r',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'o',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'v',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'i',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 's',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'i',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'o',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'n',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 's',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.3277311,
                                        y: 0.9655172,
                                    },
                                    {
                                        x: 0.34453782,
                                        y: 0.9655172,
                                    },
                                    {
                                        x: 0.34453782,
                                        y: 0.9750297,
                                    },
                                    {
                                        x: 0.3277311,
                                        y: 0.9750297,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'c',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'a',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'n',
                                    confidence: 0.99,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.34957984,
                                        y: 0.9655172,
                                    },
                                    {
                                        x: 0.35966387,
                                        y: 0.9655172,
                                    },
                                    {
                                        x: 0.35966387,
                                        y: 0.9750297,
                                    },
                                    {
                                        x: 0.34957984,
                                        y: 0.9750297,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'b',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                            ],
                            confidence: 1,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.36302522,
                                        y: 0.9655172,
                                    },
                                    {
                                        x: 0.39663866,
                                        y: 0.9655172,
                                    },
                                    {
                                        x: 0.39663866,
                                        y: 0.9750297,
                                    },
                                    {
                                        x: 0.36302522,
                                        y: 0.9750297,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'v',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'i',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'w',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'd',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.40168068,
                                        y: 0.9655172,
                                    },
                                    {
                                        x: 0.41008404,
                                        y: 0.9655172,
                                    },
                                    {
                                        x: 0.41008404,
                                        y: 0.9750297,
                                    },
                                    {
                                        x: 0.40168068,
                                        y: 0.9750297,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'a',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 't',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.41344538,
                                        y: 0.9655172,
                                    },
                                    {
                                        x: 0.5546219,
                                        y: 0.9655172,
                                    },
                                    {
                                        x: 0.5546219,
                                        y: 0.9750297,
                                    },
                                    {
                                        x: 0.41344538,
                                        y: 0.9750297,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'g',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'e',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'n',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'e',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'r',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'a',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'l',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'i',
                                    confidence: 0.94,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: '.',
                                    confidence: 0.96,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'c',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'h',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: '/',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'e',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'n',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: '/',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'd',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'a',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 't',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'a',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'p',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'r',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'o',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 't',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'c',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 't',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'i',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'o',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'n',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.55630255,
                                        y: 0.9655172,
                                    },
                                    {
                                        x: 0.5596639,
                                        y: 0.9655172,
                                    },
                                    {
                                        x: 0.5596639,
                                        y: 0.9750297,
                                    },
                                    {
                                        x: 0.55630255,
                                        y: 0.9750297,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: ',',
                                    confidence: 0.99,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.56302524,
                                        y: 0.9655172,
                                    },
                                    {
                                        x: 0.57310927,
                                        y: 0.9655172,
                                    },
                                    {
                                        x: 0.57310927,
                                        y: 0.9750297,
                                    },
                                    {
                                        x: 0.56302524,
                                        y: 0.9750297,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'o',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'r',
                                    confidence: 0.99,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.5764706,
                                        y: 0.9655172,
                                    },
                                    {
                                        x: 0.59327734,
                                        y: 0.9655172,
                                    },
                                    {
                                        x: 0.59327734,
                                        y: 0.9750297,
                                    },
                                    {
                                        x: 0.5764706,
                                        y: 0.9750297,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'y',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'o',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'u',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.59831935,
                                        y: 0.9655172,
                                    },
                                    {
                                        x: 0.6134454,
                                        y: 0.9655172,
                                    },
                                    {
                                        x: 0.6134454,
                                        y: 0.9750297,
                                    },
                                    {
                                        x: 0.59831935,
                                        y: 0.9750297,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'c',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'a',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'n',
                                    confidence: 1,
                                },
                            ],
                            confidence: 1,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.6184874,
                                        y: 0.9655172,
                                    },
                                    {
                                        x: 0.65378153,
                                        y: 0.9655172,
                                    },
                                    {
                                        x: 0.65378153,
                                        y: 0.9750297,
                                    },
                                    {
                                        x: 0.6184874,
                                        y: 0.9750297,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'r',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'q',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'u',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 's',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 't',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.6571429,
                                        y: 0.9655172,
                                    },
                                    {
                                        x: 0.6621849,
                                        y: 0.9655172,
                                    },
                                    {
                                        x: 0.6621849,
                                        y: 0.9750297,
                                    },
                                    {
                                        x: 0.6571429,
                                        y: 0.9750297,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'a',
                                    confidence: 1,
                                },
                            ],
                            confidence: 1,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.6672269,
                                        y: 0.9655172,
                                    },
                                    {
                                        x: 0.68907565,
                                        y: 0.9655172,
                                    },
                                    {
                                        x: 0.68907565,
                                        y: 0.9750297,
                                    },
                                    {
                                        x: 0.6672269,
                                        y: 0.9750297,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'c',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'o',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'p',
                                    confidence: 0.84,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'y',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.95,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.69411767,
                                        y: 0.9655172,
                                    },
                                    {
                                        x: 0.71428573,
                                        y: 0.9655172,
                                    },
                                    {
                                        x: 0.71428573,
                                        y: 0.9750297,
                                    },
                                    {
                                        x: 0.69411767,
                                        y: 0.9750297,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'f',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'r',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'o',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'm',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.71932775,
                                        y: 0.9655172,
                                    },
                                    {
                                        x: 0.7344538,
                                        y: 0.9655172,
                                    },
                                    {
                                        x: 0.7344538,
                                        y: 0.9750297,
                                    },
                                    {
                                        x: 0.71932775,
                                        y: 0.9750297,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'o',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'u',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'r',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.73781514,
                                        y: 0.9655172,
                                    },
                                    {
                                        x: 0.7831933,
                                        y: 0.9655172,
                                    },
                                    {
                                        x: 0.7831933,
                                        y: 0.9750297,
                                    },
                                    {
                                        x: 0.73781514,
                                        y: 0.9750297,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'c',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'u',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 's',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 't',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'o',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'm',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'r',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.78655463,
                                        y: 0.9655172,
                                    },
                                    {
                                        x: 0.8201681,
                                        y: 0.9655172,
                                    },
                                    {
                                        x: 0.8201681,
                                        y: 0.9750297,
                                    },
                                    {
                                        x: 0.78655463,
                                        y: 0.9750297,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 's',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'e',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'r',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'v',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'i',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'c',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'SPACE',
                                        },
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.8252101,
                                        y: 0.9655172,
                                    },
                                    {
                                        x: 0.88235295,
                                        y: 0.9655172,
                                    },
                                    {
                                        x: 0.88235295,
                                        y: 0.9750297,
                                    },
                                    {
                                        x: 0.8252101,
                                        y: 0.9750297,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'd',
                                    confidence: 0.98,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'p',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'a',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'r',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 't',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'm',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'e',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 'n',
                                    confidence: 1,
                                },
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                    },
                                    text: 't',
                                    confidence: 1,
                                },
                            ],
                            confidence: 0.99,
                        },
                        {
                            property: {
                                detectedLanguages: [
                                    {
                                        languageCode: 'en',
                                    },
                                ],
                            },
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.8806723,
                                        y: 0.9655172,
                                    },
                                    {
                                        x: 0.88235295,
                                        y: 0.9655172,
                                    },
                                    {
                                        x: 0.88235295,
                                        y: 0.9750297,
                                    },
                                    {
                                        x: 0.8806723,
                                        y: 0.9750297,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    property: {
                                        detectedLanguages: [
                                            {
                                                languageCode: 'en',
                                            },
                                        ],
                                        detectedBreak: {
                                            type: 'LINE_BREAK',
                                        },
                                    },
                                    text: '.',
                                    confidence: 0.91,
                                },
                            ],
                            confidence: 0.91,
                        },
                    ],
                    confidence: 0.99,
                },
            ],
            blockType: 'TEXT',
            confidence: 0.99,
        },
        {
            boundingBox: {
                normalizedVertices: [
                    {
                        x: 0.9092437,
                        y: 0.9667063,
                    },
                    {
                        x: 0.93109244,
                        y: 0.9667063,
                    },
                    {
                        x: 0.93109244,
                        y: 0.97384065,
                    },
                    {
                        x: 0.9092437,
                        y: 0.97384065,
                    },
                ],
            },
            paragraphs: [
                {
                    boundingBox: {
                        normalizedVertices: [
                            {
                                x: 0.9092437,
                                y: 0.9667063,
                            },
                            {
                                x: 0.93109244,
                                y: 0.9667063,
                            },
                            {
                                x: 0.93109244,
                                y: 0.97384065,
                            },
                            {
                                x: 0.9092437,
                                y: 0.97384065,
                            },
                        ],
                    },
                    words: [
                        {
                            boundingBox: {
                                normalizedVertices: [
                                    {
                                        x: 0.9092437,
                                        y: 0.9667063,
                                    },
                                    {
                                        x: 0.93109244,
                                        y: 0.9667063,
                                    },
                                    {
                                        x: 0.93109244,
                                        y: 0.97384065,
                                    },
                                    {
                                        x: 0.9092437,
                                        y: 0.97384065,
                                    },
                                ],
                            },
                            symbols: [
                                {
                                    text: '1',
                                    confidence: 0.99,
                                },
                                {
                                    text: '/',
                                    confidence: 0.99,
                                },
                                {
                                    text: '2',
                                    confidence: 0.99,
                                },
                                {
                                    property: {
                                        detectedBreak: {
                                            type: 'LINE_BREAK',
                                        },
                                    },
                                    text: '3',
                                    confidence: 0.99,
                                },
                            ],
                            confidence: 0.99,
                        },
                    ],
                    confidence: 0.99,
                },
            ],
            blockType: 'TEXT',
            confidence: 0.99,
        },
    ],
};
